// // screens/agent/AgentDashboard.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { useTheme } from '../../hooks/useTheme';
// import { useAuth } from '../../providers/AuthProvider';
// import { useToast } from '../../providers/ToastProvider';
// import { useNavigate } from 'react-router-dom';
// import {
//   Wallet,
//   TrendingUp,
//   Users,
//   Edit2,
//   Save,
//   X,
//   DollarSign,
//   Package,
//   Clock,
//   CheckCircle,
//   RefreshCw,
//   Search,
//   AlertCircle,
//   Info,
//   ChevronDown,
//   ChevronUp,
//   BarChart3,
//   Activity,
//   Award,
//   Zap,
//   ShoppingBag,
//   UserPlus,
//   ArrowUp,
//   ArrowDown,
//   Calendar,
//   Download,
//   Filter,
//   ChevronRight,
//   Percent,
//   BadgeDollarSign,
//   Coins,
//   Trash2
// } from 'lucide-react';

// const AgentDashboard = () => {
//   const { colors } = useTheme();
//   const { user, authFetch } = useAuth();
//   const { showToast } = useToast();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [packages, setPackages] = useState([]);
//   const [editingPackage, setEditingPackage] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [newPrice, setNewPrice] = useState('');
//   const [editingType, setEditingType] = useState('customer');
//   const [walletBalance, setWalletBalance] = useState(0);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedNetwork, setSelectedNetwork] = useState('ALL');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [expandedPackages, setExpandedPackages] = useState({});
//   const [activeChartTab, setActiveChartTab] = useState('revenue');
//   const [chartData, setChartData] = useState(null);
//   const [animating, setAnimating] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   // Sub-Agent Registration Fee States
//   const [subAgentFee, setSubAgentFee] = useState(null);
//   const [isEditingFee, setIsEditingFee] = useState(false);
//   const [editFeeValue, setEditFeeValue] = useState('');
//   const [isSavingFee, setIsSavingFee] = useState(false);
//   const [isResettingFee, setIsResettingFee] = useState(false);

//   // Animation refs
//   const chartRefs = useRef({});

//   // Handle resize
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   useEffect(() => {
//     if (dashboardData?.agent?.weekly) {
//       const weeklyData = dashboardData.agent.weekly;
//       const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//       const revenueData = days.map(day => {
//         const found = weeklyData.revenue?.find(r => r.day === day);
//         return found ? found.value : 0;
//       });
//       const profitData = days.map(day => {
//         const found = weeklyData.profit?.find(r => r.day === day);
//         return found ? found.value : 0;
//       });
//       const ordersData = days.map(day => {
//         const found = weeklyData.orders?.find(r => r.day === day);
//         return found ? found.value : 0;
//       });

//       setChartData({
//         labels: days,
//         revenue: revenueData,
//         profit: profitData,
//         orders: ordersData,
//         summary: weeklyData.summary || {}
//       });

//       setTimeout(() => setAnimating(true), 300);
//     }
//   }, [dashboardData]);

//   // Fetch Sub-Agent Fee
//   const fetchSubAgentFee = async () => {
//     try {
//       const response = await authFetch('/accounts/agent/sub-agent-fee/');
//       const data = await response.json();
//       if (response.ok && data.status === 'success') {
//         setSubAgentFee(data.data);
//         setEditFeeValue(data.data.current_fee || '');
//       }
//     } catch (error) {
//       console.error('Error fetching sub-agent fee:', error);
//     }
//   };

//   // Handle Edit Fee
//   const handleEditFee = () => {
//     setIsEditingFee(true);
//     setEditFeeValue(subAgentFee?.current_fee || '');
//   };

//   // Handle Cancel Edit Fee
//   const handleCancelEditFee = () => {
//     setIsEditingFee(false);
//     setEditFeeValue(subAgentFee?.current_fee || '');
//   };

//   // Handle Save Fee
//   const handleSaveFee = async () => {
//     const fee = parseFloat(editFeeValue);
//     if (isNaN(fee) || fee <= 0) {
//       showToast('Please enter a valid positive number', 'error');
//       return;
//     }

//     if (subAgentFee?.base_fee && fee < parseFloat(subAgentFee.base_fee)) {
//       showToast(`Fee cannot be less than the base fee (₵${subAgentFee.base_fee})`, 'error');
//       return;
//     }

//     setIsSavingFee(true);
//     try {
//       const method = subAgentFee?.is_custom ? 'PATCH' : 'PUT';
//       const response = await authFetch('/accounts/agent/sub-agent-fee/', {
//         method: method,
//         body: JSON.stringify({ fee: fee.toFixed(2) }),
//       });

//       const data = await response.json();

//       if (response.ok && data.status === 'success') {
//         showToast(data.message || 'Sub-agent registration fee updated successfully!', 'success');
//         setSubAgentFee(data.data);
//         setIsEditingFee(false);
//         fetchDashboardData();
//       } else {
//         if (data.errors) {
//           const firstError = Object.values(data.errors)[0];
//           showToast(Array.isArray(firstError) ? firstError[0] : firstError, 'error');
//         } else {
//           showToast(data.message || 'Failed to update fee', 'error');
//         }
//       }
//     } catch (error) {
//       console.error('Error updating fee:', error);
//       showToast('Network error. Please try again.', 'error');
//     } finally {
//       setIsSavingFee(false);
//     }
//   };

//   // Handle Reset Fee
//   const handleResetFee = async () => {
//     if (!window.confirm('Reset to base fee? This will remove your custom fee.')) return;

//     setIsResettingFee(true);
//     try {
//       const response = await authFetch('/accounts/agent/sub-agent-fee/reset/', {
//         method: 'DELETE',
//       });

//       const data = await response.json();

//       if (response.ok && data.status === 'success') {
//         showToast(data.message || 'Custom fee removed successfully.', 'success');
//         await fetchSubAgentFee();
//         fetchDashboardData();
//       } else {
//         showToast(data.message || 'Failed to reset fee', 'error');
//       }
//     } catch (error) {
//       console.error('Error resetting fee:', error);
//       showToast('Network error. Please try again.', 'error');
//     } finally {
//       setIsResettingFee(false);
//     }
//   };

//   const fetchDashboardData = async () => {
//     try {
//       setLoading(true);
//       setAnimating(false);

//       const profileResponse = await authFetch('/accounts/user/me/');
//       const profileData = await profileResponse.json();
//       if (profileResponse.ok && profileData.status === 'success') {
//         setWalletBalance(parseFloat(profileData.data.wallet?.balance || 0));
//       }

//       const statsResponse = await authFetch('/accounts/dashboard/stats/');
//       const statsData = await statsResponse.json();
//       if (statsResponse.ok && statsData.status === 'success') {
//         setDashboardData(statsData.data);
//       }

//       const packagesResponse = await authFetch('/data/packages/');
//       const packagesData = await packagesResponse.json();
//       if (packagesResponse.ok && packagesData.status === 'success') {
//         const transformedPackages = packagesData.data.map(pkg => ({
//           id: pkg.id,
//           network: pkg.network,
//           size: `${pkg.size_gb}GB`,
//           basePriceCustomer: parseFloat(pkg.base_price_customer || 0),
//           basePriceAgent: parseFloat(pkg.base_price_agent || 0),
//           effectivePrice: parseFloat(pkg.effective_price || pkg.base_price_agent || pkg.base_price_customer || 0),
//           priceSource: pkg.price_source || 'base',
//           agentCustomerPrice: pkg.agent_customer_price ? parseFloat(pkg.agent_customer_price) : null,
//           agentSubBasePrice: pkg.agent_sub_base_price ? parseFloat(pkg.agent_sub_base_price) : null,
//           agentSubCustomPrices: pkg.agent_sub_custom_prices || {},
//           isActive: pkg.is_active,
//           salesCount: pkg.sales_count || 0,
//           pricingId: pkg.pricing_id || null,
//         }));
//         setPackages(transformedPackages);
//       }

//       // Fetch sub-agent fee
//       await fetchSubAgentFee();

//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//       showToast('Failed to load dashboard data', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditPrice = (pkg, type) => {
//     setEditingPackage(pkg);
//     setEditingType(type);
//     if (type === 'customer') {
//       setNewPrice(String(pkg.agentCustomerPrice || pkg.effectivePrice || pkg.basePriceAgent));
//     } else {
//       setNewPrice(String(pkg.agentSubBasePrice || pkg.basePriceAgent));
//     }
//     setShowEditModal(true);
//   };

//   const openEditModal = (pkg, type) => {
//     setEditingPackage({
//       ...pkg,
//       pricingId: pkg.pricingId || null
//     });
//     setEditingType(type);
//     if (type === 'customer') {
//       setNewPrice(String(pkg.agentCustomerPrice || pkg.effectivePrice || pkg.basePriceAgent));
//     } else {
//       setNewPrice(String(pkg.agentSubBasePrice || pkg.basePriceAgent));
//     }
//     setShowEditModal(true);
//   };

//   // const handleSavePrice = async () => {
//   //   if (!newPrice || isNaN(newPrice) || Number(newPrice) <= 0) {
//   //     showToast('Please enter a valid price', 'error');
//   //     return;
//   //   }

//   //   if (Number(newPrice) < editingPackage.basePriceAgent) {
//   //     showToast(`Price cannot be below base agent price (₵${editingPackage.basePriceAgent.toFixed(2)})`, 'error');
//   //     return;
//   //   }

//   //   setIsSubmitting(true);
//   //   try {
//   //     const priceType = editingType === 'customer' ? 'AGENT_CUSTOMER_PRICE' : 'AGENT_SUB_BASE_PRICE';

//   //     const response = await authFetch('/data/pricing/create/', {
//   //       method: 'POST',
//   //       body: JSON.stringify({
//   //         package: editingPackage.id,
//   //         user: user.id,
//   //         price_type: priceType,
//   //         price: newPrice,
//   //         notes: `${editingType === 'customer' ? 'Customer' : 'Sub-Agent'} price for ${editingPackage.network} ${editingPackage.size}`,
//   //       }),
//   //     });

//   //     const data = await response.json();

//   //     if (response.status === 201 && data.status === 'success') {
//   //       showToast(`${editingType === 'customer' ? 'Customer' : 'Sub-Agent'} price updated successfully`, 'success');
//   //       fetchDashboardData();
//   //       setShowEditModal(false);
//   //       setEditingPackage(null);
//   //       setNewPrice('');
//   //     } else {
//   //       if (data.errors) {
//   //         const firstError = Object.values(data.errors)[0];
//   //         showToast(Array.isArray(firstError) ? firstError[0] : firstError, 'error');
//   //       } else {
//   //         showToast(data.message || 'Failed to update price', 'error');
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error('Error updating price:', error);
//   //     showToast('Network error. Please try again.', 'error');
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

//   const handleSavePrice = async () => {
//     if (!newPrice || isNaN(newPrice) || Number(newPrice) <= 0) {
//       showToast('Please enter a valid price', 'error');
//       return;
//     }

//     if (Number(newPrice) < editingPackage.basePriceAgent) {
//       showToast(`Price cannot be below base agent price (₵${editingPackage.basePriceAgent.toFixed(2)})`, 'error');
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const priceType = editingType === 'customer' ? 'AGENT_CUSTOMER_PRICE' : 'AGENT_SUB_BASE_PRICE';

//       let response;
//       let data;

//       // Check if we're editing an existing custom price
//       // For customer price: check if agentCustomerPrice exists
//       // For sub-agent price: check if agentSubBasePrice exists
//       const isEditing = editingType === 'customer'
//         ? editingPackage.agentCustomerPrice !== null
//         : editingPackage.agentSubBasePrice !== null;

//       if (isEditing) {
//         // Use PATCH to update existing price
//         // We need to find the pricing_id for this package and user
//         const pricingResponse = await authFetch(`/data/pricing/?package=${editingPackage.id}&user=${user.id}`);
//         const pricingData = await pricingResponse.json();

//         if (pricingResponse.ok && pricingData.status === 'success' && pricingData.data.length > 0) {
//           const pricingId = pricingData.data[0].id;
//           response = await authFetch(`/data/pricing/${pricingId}/`, {
//             method: 'PATCH',
//             body: JSON.stringify({
//               price: newPrice,
//               notes: `Updated ${editingType === 'customer' ? 'customer' : 'sub-agent'} price for ${editingPackage.network} ${editingPackage.size}`,
//             }),
//           });
//         } else {
//           // If no pricing record found, create new one
//           response = await authFetch('/data/pricing/create/', {
//             method: 'POST',
//             body: JSON.stringify({
//               package: editingPackage.id,
//               user: user.id,
//               price_type: priceType,
//               price: newPrice,
//               notes: `${editingType === 'customer' ? 'Customer' : 'Sub-Agent'} price for ${editingPackage.network} ${editingPackage.size}`,
//             }),
//           });
//         }
//       } else {
//         // Create new price
//         response = await authFetch('/data/pricing/create/', {
//           method: 'POST',
//           body: JSON.stringify({
//             package: editingPackage.id,
//             user: user.id,
//             price_type: priceType,
//             price: newPrice,
//             notes: `${editingType === 'customer' ? 'Customer' : 'Sub-Agent'} price for ${editingPackage.network} ${editingPackage.size}`,
//           }),
//         });
//       }

//       data = await response.json();

//       if ((response.status === 201 || response.status === 200) && data.status === 'success') {
//         showToast(`${editingType === 'customer' ? 'Customer' : 'Sub-Agent'} price updated successfully`, 'success');
//         fetchDashboardData();
//         setShowEditModal(false);
//         setEditingPackage(null);
//         setNewPrice('');
//       } else {
//         if (data.errors) {
//           const firstError = Object.values(data.errors)[0];
//           showToast(Array.isArray(firstError) ? firstError[0] : firstError, 'error');
//         } else {
//           showToast(data.message || 'Failed to update price', 'error');
//         }
//       }
//     } catch (error) {
//       console.error('Error updating price:', error);
//       showToast('Network error. Please try again.', 'error');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };



//   const getPriceSourceBadge = (source) => {
//     const badges = {
//       'admin_custom': { label: 'Admin Special', color: '#3B82F6', bg: '#3B82F620' },
//       'agent_custom': { label: 'Your Price', color: '#10B981', bg: '#10B98120' },
//       'agent_sub_custom': { label: 'Sub-Agent Custom', color: '#F59E0B', bg: '#F59E0B20' },
//       'sub_agent_custom': { label: 'Sub-Agent Price', color: '#8B5CF6', bg: '#8B5CF620' },
//       'agent_base': { label: 'Agent Base', color: '#F97316', bg: '#F9731620' },
//       'base': { label: 'Base Price', color: '#6B7280', bg: '#6B728020' },
//     };
//     return badges[source] || badges['base'];
//   };

//   const getNetworkColor = (network) => {
//     const colors = {
//       'MTN': '#FFD700',
//       'Telecel': '#FF0000',
//       'AirtelTigo': '#1A73E8',
//     };
//     return colors[network] || colors.btnBg;
//   };

//   const getNetworkBgColor = (network) => {
//     const colors = {
//       'MTN': '#FFFDE7',
//       'Telecel': '#FFEBEE',
//       'AirtelTigo': '#E8F0FE',
//     };
//     return colors[network] || '#F3F4F6';
//   };

//   const toggleExpand = (pkgId) => {
//     setExpandedPackages(prev => ({
//       ...prev,
//       [pkgId]: !prev[pkgId]
//     }));
//   };

//   const filteredPackages = packages.filter(pkg => {
//     const matchesSearch = pkg.network.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       pkg.size.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesNetwork = selectedNetwork === 'ALL' || pkg.network === selectedNetwork;
//     return matchesSearch && matchesNetwork && pkg.isActive;
//   });

//   const networks = ['ALL', 'MTN', 'Telecel', 'AirtelTigo'];

//   // Calculate profit for a package
//   const calculateProfit = (pkg, type) => {
//     if (type === 'customer') {
//       if (!pkg.agentCustomerPrice) return null;
//       return pkg.agentCustomerPrice - pkg.basePriceAgent;
//     } else {
//       if (!pkg.agentSubBasePrice) return null;
//       return pkg.agentSubBasePrice - pkg.basePriceAgent;
//     }
//   };

//   // Render chart
//   const renderChart = () => {
//     if (!chartData) return null;

//     const dataMap = {
//       revenue: { data: chartData.revenue, color: colors.btnBg, label: 'Revenue' },
//       profit: { data: chartData.profit, color: '#10B981', label: 'Profit' },
//       orders: { data: chartData.orders, color: '#F59E0B', label: 'Orders' },
//     };

//     const current = dataMap[activeChartTab];
//     const maxValue = Math.max(...current.data, 1);
//     const labels = chartData.labels;

//     return (
//       <div style={{
//         width: '100%',
//         height: '100%',
//         minHeight: isMobile ? '140px' : '180px',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '4px',
//       }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '4px',
//           flexWrap: 'wrap',
//           gap: '4px',
//         }}>
//           <span style={{
//             fontSize: isMobile ? '10px' : '12px',
//             fontWeight: '600',
//             color: colors.secondaryText,
//           }}>
//             {current.label} Overview
//           </span>
//           <div style={{
//             display: 'flex',
//             gap: '2px',
//           }}>
//             {['revenue', 'profit', 'orders'].map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveChartTab(tab)}
//                 style={{
//                   padding: isMobile ? '2px 8px' : '3px 10px',
//                   borderRadius: '4px',
//                   border: 'none',
//                   backgroundColor: activeChartTab === tab ? colors.btnBg : 'transparent',
//                   color: activeChartTab === tab ? colors.btnText : colors.secondaryText,
//                   cursor: 'pointer',
//                   fontSize: isMobile ? '7px' : '9px',
//                   fontWeight: activeChartTab === tab ? '600' : '500',
//                   transition: 'all 0.2s ease',
//                   textTransform: 'capitalize',
//                 }}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div style={{
//           display: 'flex',
//           alignItems: 'flex-end',
//           height: isMobile ? '100px' : '140px',
//           gap: isMobile ? '3px' : '5px',
//           padding: '0 2px',
//           position: 'relative',
//         }}>
//           {current.data.map((value, index) => {
//             const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
//             const barHeight = Math.max(percentage, 3);

//             return (
//               <div
//                 key={index}
//                 style={{
//                   flex: 1,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   gap: '2px',
//                   height: '100%',
//                   justifyContent: 'flex-end',
//                 }}
//               >
//                 <div style={{
//                   width: '100%',
//                   maxWidth: isMobile ? '18px' : '28px',
//                   height: `${animating ? barHeight : 0}%`,
//                   minHeight: animating ? '3px' : '0',
//                   background: `linear-gradient(180deg, ${current.color}, ${current.color}88)`,
//                   borderRadius: '3px 3px 0 0',
//                   transition: 'height 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                   position: 'relative',
//                   boxShadow: `0 2px 6px ${current.color}33`,
//                 }}>
//                   {animating && value > 0 && (
//                     <div style={{
//                       position: 'absolute',
//                       top: isMobile ? '-12px' : '-16px',
//                       left: '50%',
//                       transform: 'translateX(-50%)',
//                       fontSize: isMobile ? '6px' : '8px',
//                       fontWeight: '700',
//                       color: current.color,
//                       opacity: 0.8,
//                       whiteSpace: 'nowrap',
//                     }}>
//                       {value}
//                     </div>
//                   )}
//                 </div>
//                 <span style={{
//                   fontSize: isMobile ? '6px' : '8px',
//                   color: colors.secondaryText,
//                   fontWeight: '500',
//                 }}>
//                   {labels[index]}
//                 </span>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const agentStats = dashboardData?.agent || {};
//   const totalRevenue = parseFloat(agentStats.total_revenue || 0);
//   const totalProfit = parseFloat(agentStats.total_profit || 0);
//   const totalOrders = agentStats.total_orders || 0;
//   const totalSubAgents = agentStats.total_sub_agents || 0;
//   const pendingOrders = dashboardData?.pending_orders || 0;
//   const completedOrders = agentStats.completed_orders || 0;
//   const shopName = agentStats.shop_name || 'My Store';
//   const storeUrl = agentStats.store_url || '';

//   if (loading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '400px',
//         flexDirection: 'column',
//         gap: '16px',
//       }}>
//         <div className="spinner" style={{
//           width: '40px',
//           height: '40px',
//           border: `3px solid ${colors.border}`,
//           borderTop: `3px solid ${colors.btnBg}`,
//           borderRadius: '50%',
//           animation: 'spin 1s linear infinite',
//         }} />
//         <span style={{ color: colors.secondaryText, fontSize: '14px' }}>
//           Loading dashboard...
//         </span>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '0 12px 24px',
//       width: '100%',
//       boxSizing: 'border-box',
//     }}>
//       {/* Header */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start',
//         marginBottom: isMobile ? '16px' : '20px',
//         flexWrap: 'wrap',
//         gap: isMobile ? '8px' : '12px',
//       }}>
//         <div>
//           <h1 style={{
//             fontSize: isMobile ? 'clamp(18px, 5vw, 22px)' : 'clamp(20px, 2.5vw, 28px)',
//             fontWeight: '700',
//             color: colors.heading,
//             margin: '0 0 2px 0',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '8px',
//             flexWrap: 'wrap',
//           }}>
//             <Activity size={isMobile ? 20 : 24} style={{ color: colors.btnBg }} />
//             Agent Dashboard
//             {shopName && !isMobile && (
//               <span style={{
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 color: colors.secondaryText,
//                 background: colors.border,
//                 padding: '2px 12px',
//                 borderRadius: '12px',
//               }}>
//                 {shopName}
//               </span>
//             )}
//           </h1>
//           <p style={{
//             color: colors.secondaryText,
//             margin: 0,
//             fontSize: isMobile ? '12px' : '13px',
//           }}>
//             Welcome back, {user?.first_name || user?.username || 'Agent'}
//             {storeUrl && ` • ${storeUrl}.azoeshop.store`}
//           </p>
//         </div>
//         <div style={{
//           display: 'flex',
//           gap: isMobile ? '4px' : '8px',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//         }}>
//           <button
//             onClick={fetchDashboardData}
//             style={{
//               padding: isMobile ? '4px 10px' : '6px 12px',
//               borderRadius: '8px',
//               border: `1px solid ${colors.border}`,
//               backgroundColor: colors.raisedBg,
//               color: colors.text,
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '4px',
//               fontSize: isMobile ? '10px' : '12px',
//               transition: 'all 0.2s',
//               whiteSpace: 'nowrap',
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//             onMouseLeave={(e) => e.currentTarget.style.background = colors.raisedBg}
//           >
//             <RefreshCw size={isMobile ? 12 : 14} />
//             {!isMobile && 'Refresh'}
//           </button>
//         </div>
//       </div>

//       <div style={{
//         marginBottom: '24px',
//       }}>

//         {/* Stats Grid */}
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(130px, 1fr))',
//           gap: isMobile ? '6px' : '10px',
//           marginBottom: isMobile ? '12px' : '20px',
//           width: '100%',
//           boxSizing: 'border-box',
//         }}>
//           <StatCard
//             icon={<TrendingUp size={isMobile ? 16 : 18} />}
//             label="Revenue"
//             value={`₵${totalRevenue.toFixed(2)}`}
//             change="+12.5%"
//             positive={true}
//             color={colors.btnBg}
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <StatCard
//             icon={<DollarSign size={isMobile ? 16 : 18} />}
//             label="Profit"
//             value={`₵${totalProfit.toFixed(2)}`}
//             change="+8.2%"
//             positive={true}
//             color="#10B981"
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <StatCard
//             icon={<ShoppingBag size={isMobile ? 16 : 18} />}
//             label="Orders"
//             value={totalOrders}
//             change={`${pendingOrders} pending`}
//             positive={true}
//             color="#F59E0B"
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <StatCard
//             icon={<Users size={isMobile ? 16 : 18} />}
//             label="Sub Agents"
//             value={totalSubAgents}
//             change="Active"
//             positive={true}
//             color="#8B5CF6"
//             colors={colors}
//             isMobile={isMobile}
//           />
//         </div>

//         {/* Sub-Agent Registration Fee Section */}
//         {subAgentFee && (
//           <div style={{
//             backgroundColor: colors.raisedBg,
//             borderRadius: isMobile ? '10px' : '12px',
//             border: `1px solid ${colors.border}`,
//             padding: isMobile ? '12px 14px' : '16px 20px',
//             marginBottom: isMobile ? '12px' : '16px',
//             width: '100%',
//             boxSizing: 'border-box',
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: '8px',
//               marginBottom: isMobile ? '8px' : '12px',
//             }}>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//               }}>
//                 <Coins size={isMobile ? 18 : 20} style={{ color: colors.btnBg }} />
//                 <span style={{
//                   fontWeight: '600',
//                   fontSize: isMobile ? '14px' : '16px',
//                   color: colors.heading,
//                 }}>
//                   Sub-Agent Registration Fee
//                 </span>
//                 {subAgentFee.is_custom && (
//                   <span style={{
//                     fontSize: isMobile ? '8px' : '10px',
//                     padding: isMobile ? '1px 8px' : '2px 12px',
//                     borderRadius: '12px',
//                     backgroundColor: colors.warningBg,
//                     color: colors.warning,
//                     fontWeight: '600',
//                   }}>
//                     Custom
//                   </span>
//                 )}
//                 <span style={{
//                   fontSize: isMobile ? '8px' : '10px',
//                   padding: isMobile ? '1px 8px' : '2px 10px',
//                   borderRadius: '12px',
//                   backgroundColor: `${colors.btnBg}15`,
//                   color: colors.btnBg,
//                   fontWeight: '600',
//                 }}>
//                   {subAgentFee.sub_agent_count || 0} sub-agents
//                 </span>
//               </div>
//               {!isEditingFee ? (
//                 <div style={{
//                   display: 'flex',
//                   gap: '6px',
//                 }}>
//                   <button
//                     onClick={handleEditFee}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '4px',
//                       padding: isMobile ? '4px 10px' : '6px 14px',
//                       borderRadius: '8px',
//                       border: `1px solid ${colors.border}`,
//                       backgroundColor: 'transparent',
//                       color: colors.secondaryText,
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '11px' : '12px',
//                       transition: 'all 0.2s',
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = colors.hoverBg;
//                       e.currentTarget.style.color = colors.heading;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = 'transparent';
//                       e.currentTarget.style.color = colors.secondaryText;
//                     }}
//                   >
//                     <Edit2 size={isMobile ? 14 : 16} />
//                     Edit
//                   </button>
//                   {subAgentFee.is_custom && (
//                     <button
//                       onClick={handleResetFee}
//                       disabled={isResettingFee}
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '4px',
//                         padding: isMobile ? '4px 10px' : '6px 14px',
//                         borderRadius: '8px',
//                         border: `1px solid ${colors.border}`,
//                         backgroundColor: 'transparent',
//                         color: colors.error,
//                         cursor: isResettingFee ? 'not-allowed' : 'pointer',
//                         fontSize: isMobile ? '11px' : '12px',
//                         opacity: isResettingFee ? 0.5 : 1,
//                         transition: 'all 0.2s',
//                       }}
//                       onMouseEnter={(e) => {
//                         if (!isResettingFee) {
//                           e.currentTarget.style.background = colors.errorBg;
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.background = 'transparent';
//                       }}
//                     >
//                       {isResettingFee ? (
//                         <>
//                           <div className="spinner-small" style={{
//                             width: '12px',
//                             height: '12px',
//                             border: `2px solid ${colors.error}40`,
//                             borderTop: `2px solid ${colors.error}`,
//                             borderRadius: '50%',
//                             animation: 'spin 0.8s linear infinite',
//                           }} />
//                           Resetting...
//                         </>
//                       ) : (
//                         <>
//                           <Trash2 size={isMobile ? 14 : 16} />
//                           Reset
//                         </>
//                       )}
//                     </button>
//                   )}
//                 </div>
//               ) : (
//                 <div style={{
//                   display: 'flex',
//                   gap: '6px',
//                 }}>
//                   <button
//                     onClick={handleCancelEditFee}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '4px',
//                       padding: isMobile ? '4px 10px' : '6px 14px',
//                       borderRadius: '8px',
//                       border: `1px solid ${colors.border}`,
//                       backgroundColor: 'transparent',
//                       color: colors.secondaryText,
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '11px' : '12px',
//                       transition: 'all 0.2s',
//                     }}
//                   >
//                     <X size={isMobile ? 14 : 16} />
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSaveFee}
//                     disabled={isSavingFee}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '4px',
//                       padding: isMobile ? '4px 10px' : '6px 14px',
//                       borderRadius: '8px',
//                       border: 'none',
//                       backgroundColor: colors.btnBg,
//                       color: colors.btnText,
//                       cursor: isSavingFee ? 'not-allowed' : 'pointer',
//                       fontSize: isMobile ? '11px' : '12px',
//                       fontWeight: '600',
//                       opacity: isSavingFee ? 0.7 : 1,
//                       transition: 'all 0.2s',
//                     }}
//                   >
//                     {isSavingFee ? (
//                       <>
//                         <div className="spinner-small" style={{
//                           width: '12px',
//                           height: '12px',
//                           border: `2px solid ${colors.btnText}40`,
//                           borderTop: `2px solid ${colors.btnText}`,
//                           borderRadius: '50%',
//                           animation: 'spin 0.8s linear infinite',
//                         }} />
//                         Saving...
//                       </>
//                     ) : (
//                       <>
//                         <Save size={isMobile ? 14 : 16} />
//                         Save
//                       </>
//                     )}
//                   </button>
//                 </div>
//               )}
//             </div>

//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
//               gap: isMobile ? '8px' : '12px',
//             }}>
//               <div>
//                 <div style={{
//                   fontSize: isMobile ? '10px' : '12px',
//                   color: colors.secondaryText,
//                   marginBottom: '2px',
//                   fontWeight: '500',
//                 }}>
//                   {subAgentFee.is_custom ? 'Your Custom Fee' : 'Base Fee'}
//                 </div>
//                 {isEditingFee ? (
//                   <div style={{
//                     position: 'relative',
//                     display: 'flex',
//                     alignItems: 'center',
//                   }}>
//                     <span style={{
//                       position: 'absolute',
//                       left: '10px',
//                       color: colors.secondaryText,
//                       fontWeight: '600',
//                       fontSize: isMobile ? '14px' : '16px',
//                     }}>
//                       ₵
//                     </span>
//                     <input
//                       type="number"
//                       value={editFeeValue}
//                       onChange={(e) => setEditFeeValue(e.target.value)}
//                       min={subAgentFee.base_fee}
//                       step="0.01"
//                       placeholder={`Min: ₵${subAgentFee.base_fee}`}
//                       style={{
//                         width: '100%',
//                         padding: isMobile ? '7px 10px 7px 28px' : '9px 12px 9px 32px',
//                         borderRadius: '8px',
//                         border: `1.5px solid ${colors.btnBg}`,
//                         backgroundColor: colors.raisedBg,
//                         color: colors.text,
//                         fontSize: isMobile ? '14px' : '16px',
//                         outline: 'none',
//                         fontWeight: '600',
//                       }}
//                       autoFocus
//                     />
//                   </div>
//                 ) : (
//                   <div style={{
//                     fontSize: isMobile ? '20px' : '24px',
//                     fontWeight: '700',
//                     color: subAgentFee.is_custom ? colors.btnBg : colors.secondaryText,
//                   }}>
//                     ₵{subAgentFee.current_fee || subAgentFee.base_fee || '0.00'}
//                   </div>
//                 )}
//               </div>
//               <div>
//                 <div style={{
//                   fontSize: isMobile ? '10px' : '12px',
//                   color: colors.secondaryText,
//                   marginBottom: '2px',
//                   fontWeight: '500',
//                 }}>
//                   Base Fee
//                 </div>
//                 <div style={{
//                   fontSize: isMobile ? '18px' : '22px',
//                   fontWeight: '700',
//                   color: colors.secondaryText,
//                 }}>
//                   ₵{subAgentFee.base_fee || '0.00'}
//                 </div>
//               </div>
//               <div>
//                 <div style={{
//                   fontSize: isMobile ? '10px' : '12px',
//                   color: colors.secondaryText,
//                   marginBottom: '2px',
//                   fontWeight: '500',
//                 }}>
//                   Your Profit
//                 </div>
//                 <div style={{
//                   fontSize: isMobile ? '18px' : '22px',
//                   fontWeight: '700',
//                   color: subAgentFee.profit && parseFloat(subAgentFee.profit) > 0 ? '#10B981' : colors.secondaryText,
//                 }}>
//                   {subAgentFee.profit && parseFloat(subAgentFee.profit) > 0 ? (
//                     <>₵{subAgentFee.profit}</>
//                   ) : (
//                     '—'
//                   )}
//                 </div>
//               </div>
//             </div>

//             {subAgentFee.updated_at && !isEditingFee && (
//               <div style={{
//                 fontSize: isMobile ? '8px' : '10px',
//                 color: colors.secondaryText,
//                 opacity: 0.5,
//                 marginTop: isMobile ? '6px' : '8px',
//                 paddingTop: isMobile ? '6px' : '8px',
//                 borderTop: `1px solid ${colors.border}`,
//               }}>
//                 Last updated: {new Date(subAgentFee.updated_at).toLocaleDateString('en-US', {
//                   year: 'numeric',
//                   month: 'short',
//                   day: 'numeric',
//                   hour: '2-digit',
//                   minute: '2-digit',
//                 })}
//               </div>
//             )}
//           </div>
//         )}

//         {/* Quick Stats Row */}
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(120px, 1fr))',
//           gap: isMobile ? '4px' : '8px',
//           marginBottom: isMobile ? '10px' : '20px',
//           width: '100%',
//           boxSizing: 'border-box',
//         }}>
//           <QuickStat
//             label="Wallet"
//             value={`₵${walletBalance.toFixed(2)}`}
//             icon={<Wallet size={isMobile ? 14 : 16} />}
//             color="#8B5CF6"
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <QuickStat
//             label="Completed"
//             value={completedOrders}
//             icon={<CheckCircle size={isMobile ? 14 : 16} />}
//             color="#10B981"
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <QuickStat
//             label="Sub-Agent Sales"
//             value={agentStats.transactions_from_shop || 0}
//             icon={<UserPlus size={isMobile ? 14 : 16} />}
//             color="#3B82F6"
//             colors={colors}
//             isMobile={isMobile}
//           />
//           <QuickStat
//             label="Revenue"
//             value={`₵${totalRevenue.toFixed(2)}`}
//             icon={<BarChart3 size={isMobile ? 14 : 16} />}
//             color={colors.btnBg}
//             colors={colors}
//             isMobile={isMobile}
//           />
//         </div>

//       </div>

//       {/* Chart Section */}
//       <div style={{
//         backgroundColor: colors.raisedBg,
//         borderRadius: isMobile ? '10px' : '14px',
//         border: `1px solid ${colors.border}`,
//         padding: isMobile ? '10px 12px' : '14px 16px',
//         marginBottom: isMobile ? '12px' : '20px',
//         boxShadow: `0 2px 8px ${colors.shadow}`,
//         width: '100%',
//         boxSizing: 'border-box',
//       }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: isMobile ? '6px' : '10px',
//           flexWrap: 'wrap',
//           gap: isMobile ? '4px' : '8px',
//         }}>
//           <div style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: isMobile ? '4px' : '8px',
//           }}>
//             <BarChart3 size={isMobile ? 14 : 18} style={{ color: colors.btnBg }} />
//             <span style={{
//               fontWeight: '600',
//               fontSize: isMobile ? '12px' : '14px',
//               color: colors.heading,
//             }}>
//               Performance Analytics
//             </span>
//           </div>
//           {chartData?.summary && (
//             <div style={{
//               display: 'flex',
//               gap: isMobile ? '6px' : '10px',
//               fontSize: isMobile ? '8px' : '10px',
//               color: colors.secondaryText,
//               flexWrap: 'wrap',
//             }}>
//               <span>Orders: <strong style={{ color: colors.text }}>{chartData.summary.total_orders || 0}</strong></span>
//               <span>Revenue: <strong style={{ color: colors.text }}>₵{(chartData.summary.total_revenue || 0).toFixed(2)}</strong></span>
//               {!isMobile && (
//                 <span>Profit: <strong style={{ color: colors.text }}>₵{(chartData.summary.total_profit || 0).toFixed(2)}</strong></span>
//               )}
//             </div>
//           )}
//         </div>
//         <div style={{
//           width: '100%',
//           minHeight: isMobile ? '140px' : '190px',
//         }}>
//           {renderChart()}
//         </div>
//       </div>

//       {/* Recent Orders */}
//       {dashboardData?.agent?.recent_orders?.length > 0 && (
//         <div style={{
//           backgroundColor: colors.raisedBg,
//           borderRadius: isMobile ? '10px' : '14px',
//           border: `1px solid ${colors.border}`,
//           overflow: 'hidden',
//           marginBottom: isMobile ? '12px' : '20px',
//           width: '100%',
//           boxSizing: 'border-box',
//         }}>
//           <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             padding: isMobile ? '10px 12px' : '12px 16px',
//             borderBottom: `1px solid ${colors.border}`,
//             flexWrap: 'wrap',
//             gap: '4px',
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '6px',
//             }}>
//               <Clock size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
//               <span style={{
//                 fontWeight: '600',
//                 fontSize: isMobile ? '12px' : '14px',
//                 color: colors.heading,
//               }}>
//                 Recent Orders
//               </span>
//             </div>
//             <button
//               onClick={() => navigate('/orders')}
//               style={{
//                 fontSize: isMobile ? '10px' : '12px',
//                 color: colors.btnBg,
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '2px',
//                 fontWeight: '500',
//               }}
//             >
//               View All <ChevronRight size={isMobile ? 12 : 14} />
//             </button>
//           </div>
//           <div style={{
//             overflowX: 'auto',
//             WebkitOverflowScrolling: 'touch',
//           }}>
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: isMobile ? '0.7fr 1fr 0.7fr 0.7fr' : '0.8fr 1.2fr 0.8fr 0.8fr',
//               padding: isMobile ? '6px 12px' : '8px 16px',
//               borderBottom: `1px solid ${colors.border}`,
//               fontSize: isMobile ? '8px' : '10px',
//               fontWeight: '600',
//               color: colors.secondaryText,
//               textTransform: 'uppercase',
//               minWidth: isMobile ? '280px' : '320px',
//             }}>
//               <span>Order</span>
//               <span>Customer</span>
//               <span>Amount</span>
//               <span>Status</span>
//             </div>
//             {dashboardData.agent.recent_orders.slice(0, 5).map((order) => (
//               <div
//                 key={order.id}
//                 style={{
//                   display: 'grid',
//                   gridTemplateColumns: isMobile ? '0.7fr 1fr 0.7fr 0.7fr' : '0.8fr 1.2fr 0.8fr 0.8fr',
//                   padding: isMobile ? '6px 12px' : '8px 16px',
//                   borderBottom: `1px solid ${colors.border}`,
//                   alignItems: 'center',
//                   fontSize: isMobile ? '10px' : '12px',
//                   minWidth: isMobile ? '280px' : '320px',
//                   transition: 'background 0.2s',
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//               >
//                 <span style={{
//                   fontWeight: '500',
//                   color: colors.heading,
//                   fontSize: isMobile ? '9px' : '11px',
//                 }}>
//                   {order.id?.slice(0, 8) || 'N/A'}
//                 </span>
//                 <span style={{
//                   color: colors.text,
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: 'nowrap',
//                   fontSize: isMobile ? '9px' : '12px',
//                 }}>
//                   {order.customer || 'N/A'}
//                 </span>
//                 <span style={{
//                   fontWeight: '600',
//                   color: colors.btnBg,
//                   fontSize: isMobile ? '10px' : '12px',
//                 }}>
//                   ₵{order.amount || '0.00'}
//                 </span>
//                 <span style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '2px',
//                   color: order.status === 'COMPLETED' ? '#10B981' :
//                     order.status === 'PENDING' ? '#F59E0B' :
//                       order.status === 'PROCESSING' ? '#3B82F6' : '#EF4444',
//                   fontSize: isMobile ? '8px' : '10px',
//                   fontWeight: '600',
//                   textTransform: 'capitalize',
//                 }}>
//                   {order.status === 'COMPLETED' && <CheckCircle size={isMobile ? 10 : 12} />}
//                   {order.status === 'PENDING' && <Clock size={isMobile ? 10 : 12} />}
//                   {order.status === 'PROCESSING' && <RefreshCw size={isMobile ? 10 : 12} />}
//                   {order.status === 'FAILED' && <AlertCircle size={isMobile ? 10 : 12} />}
//                   {isMobile ? getStatusLabel(order.status).slice(0, 3) : order.status?.toLowerCase() || 'N/A'}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Packages Section */}
//       <div style={{
//         marginBottom: '24px',
//       }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: isMobile ? '10px' : '12px',
//           flexWrap: 'wrap',
//           gap: '8px',
//         }}>
//           <div style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '6px',
//           }}>
//             <Package size={isMobile ? 16 : 20} style={{ color: colors.btnBg }} />
//             <h2 style={{
//               fontSize: isMobile ? '16px' : '18px',
//               fontWeight: '700',
//               color: colors.heading,
//               margin: 0,
//             }}>
//               My Packages
//             </h2>
//             <span style={{
//               fontSize: isMobile ? '9px' : '11px',
//               color: colors.secondaryText,
//               background: colors.border,
//               padding: '1px 8px',
//               borderRadius: '8px',
//             }}>
//               {packages.length}
//             </span>
//           </div>
//         </div>

//         {/* Search & Filter */}
//         <div style={{
//           display: 'flex',
//           gap: isMobile ? '4px' : '8px',
//           marginBottom: isMobile ? '8px' : '12px',
//           flexWrap: 'wrap',
//           width: '100%',
//           boxSizing: 'border-box',
//         }}>
//           <div style={{
//             flex: 1,
//             position: 'relative',
//             minWidth: isMobile ? '100px' : '160px',
//           }}>
//             <Search
//               size={isMobile ? 12 : 15}
//               style={{
//                 position: 'absolute',
//                 left: isMobile ? '8px' : '10px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 color: colors.secondaryText,
//               }}
//             />
//             <input
//               type="text"
//               placeholder={isMobile ? "Search..." : "Search packages..."}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               style={{
//                 width: '100%',
//                 padding: isMobile ? '5px 8px 5px 28px' : '7px 10px 7px 32px',
//                 borderRadius: '8px',
//                 border: `1.5px solid ${searchQuery ? colors.btnBg : colors.border}`,
//                 backgroundColor: colors.raisedBg,
//                 color: colors.text,
//                 fontSize: isMobile ? '11px' : '12px',
//                 outline: 'none',
//                 transition: 'all 0.2s',
//                 minHeight: isMobile ? '32px' : '36px',
//                 boxShadow: searchQuery ? `0 0 0 3px ${colors.btnBg}20` : 'none',
//               }}
//               onFocus={(e) => {
//                 e.target.style.borderColor = colors.btnBg;
//                 e.target.style.boxShadow = `0 0 0 3px ${colors.btnBg}20`;
//               }}
//               onBlur={(e) => {
//                 if (!searchQuery) {
//                   e.target.style.borderColor = colors.border;
//                   e.target.style.boxShadow = 'none';
//                 }
//               }}
//             />
//             {searchQuery && (
//               <button
//                 onClick={() => setSearchQuery('')}
//                 style={{
//                   position: 'absolute',
//                   right: isMobile ? '4px' : '8px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: colors.secondaryText,
//                 }}
//               >
//                 <X size={isMobile ? 12 : 14} />
//               </button>
//             )}
//           </div>

//           <div style={{
//             display: 'flex',
//             gap: '2px',
//             padding: '2px',
//             backgroundColor: colors.raisedBg,
//             borderRadius: '6px',
//             border: `1px solid ${colors.border}`,
//           }}>
//             {networks.map((network) => (
//               <button
//                 key={network}
//                 onClick={() => setSelectedNetwork(network)}
//                 style={{
//                   padding: isMobile ? '2px 8px' : '3px 10px',
//                   borderRadius: '4px',
//                   border: 'none',
//                   backgroundColor: selectedNetwork === network ? colors.btnBg : 'transparent',
//                   color: selectedNetwork === network ? colors.btnText : colors.secondaryText,
//                   cursor: 'pointer',
//                   fontSize: isMobile ? '8px' : '10px',
//                   fontWeight: selectedNetwork === network ? '600' : '500',
//                   transition: 'all 0.2s',
//                   textTransform: 'capitalize',
//                 }}
//               >
//                 {isMobile ? network.substring(0, 3) : network.toLowerCase()}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))',
//           gap: isMobile ? '8px' : '10px',
//           width: '100%',
//           boxSizing: 'border-box',
//         }}>
//           {filteredPackages.map((pkg) => {
//             const badge = getPriceSourceBadge(pkg.priceSource);
//             const isExpanded = expandedPackages[pkg.id] || false;
//             const hasSubAgentCustomPrices = Object.keys(pkg.agentSubCustomPrices || {}).length > 0;
//             const subAgentCustomCount = Object.keys(pkg.agentSubCustomPrices || {}).length;
//             const networkColor = getNetworkColor(pkg.network);
//             const networkBg = getNetworkBgColor(pkg.network);

//             // Calculate profits
//             const customerProfit = calculateProfit(pkg, 'customer');
//             const subAgentProfit = calculateProfit(pkg, 'subAgent');
//             const hasCustomerProfit = customerProfit !== null && customerProfit > 0;
//             const hasSubAgentProfit = subAgentProfit !== null && subAgentProfit > 0;

//             return (
//               <div
//                 key={pkg.id}
//                 style={{
//                   backgroundColor: networkBg,
//                   borderRadius: isMobile ? '10px' : '12px',
//                   padding: isMobile ? '10px 12px' : '14px 16px',
//                   border: `1px solid ${colors.border}`,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: isMobile ? '4px' : '6px',
//                   transition: 'all 0.3s ease',
//                   width: '100%',
//                   boxSizing: 'border-box',
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-2px)';
//                   e.currentTarget.style.boxShadow = `0 4px 16px ${colors.shadow}`;
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0)';
//                   e.currentTarget.style.boxShadow = 'none';
//                 }}
//               >
//                 {/* Header */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'flex-start',
//                   flexWrap: 'wrap',
//                   gap: '4px',
//                 }}>
//                   <div>
//                     <div style={{
//                       fontSize: isMobile ? '9px' : '10px',
//                       fontWeight: '600',
//                       color: networkColor,
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.5px',
//                     }}>
//                       {pkg.network}
//                     </div>
//                     <div style={{
//                       fontSize: isMobile ? '15px' : '17px',
//                       fontWeight: '700',
//                       color: colors.heading,
//                     }}>
//                       {pkg.size}
//                     </div>
//                   </div>
//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '4px',
//                     flexWrap: 'wrap',
//                   }}>
//                     <span style={{
//                       fontSize: isMobile ? '7px' : '8px',
//                       padding: isMobile ? '1px 8px' : '2px 10px',
//                       borderRadius: '8px',
//                       backgroundColor: badge.bg,
//                       color: badge.color,
//                       fontWeight: '600',
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.3px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '2px',
//                     }}>
//                       <Info size={isMobile ? 8 : 10} />
//                       {isMobile ? badge.label.substring(0, 6) : badge.label}
//                     </span>
//                     {pkg.salesCount > 0 && (
//                       <span style={{
//                         fontSize: isMobile ? '7px' : '8px',
//                         padding: isMobile ? '1px 6px' : '2px 8px',
//                         borderRadius: '8px',
//                         backgroundColor: `${colors.btnBg}15`,
//                         color: colors.btnBg,
//                         fontWeight: '600',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '2px',
//                       }}>
//                         <Zap size={isMobile ? 8 : 10} />
//                         {pkg.salesCount}
//                       </span>
//                     )}
//                   </div>
//                 </div>

//                 {/* Admin Agent Base - Only this base price */}
//                 <div style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr',
//                   gap: isMobile ? '2px' : '4px',
//                   paddingTop: isMobile ? '4px' : '6px',
//                   borderTop: `1px solid ${colors.border}`,
//                 }}>
//                   <div>
//                     <div style={{
//                       fontSize: isMobile ? '7px' : '8px',
//                       color: colors.secondaryText,
//                       textTransform: 'uppercase'
//                     }}>
//                       Admin Agent Base
//                     </div>
//                     <div style={{
//                       fontSize: isMobile ? '11px' : '13px',
//                       fontWeight: '500',
//                       color: colors.text,
//                     }}>
//                       ₵{pkg.basePriceAgent.toFixed(2)}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Agent Prices with Profit Display */}
//                 <div style={{
//                   display: 'grid',
//                   gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr',
//                   gap: isMobile ? '2px' : '4px',
//                   padding: isMobile ? '4px 6px' : '5px 8px',
//                   backgroundColor: `${colors.btnBg}08`,
//                   borderRadius: '6px',
//                 }}>
//                   <div>
//                     <div style={{
//                       fontSize: isMobile ? '7px' : '8px',
//                       color: colors.secondaryText,
//                       textTransform: 'uppercase'
//                     }}>
//                       Your Customer Price
//                     </div>
//                     <div style={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '1px',
//                     }}>
//                       <span style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         fontWeight: '700',
//                         color: pkg.agentCustomerPrice ? colors.btnBg : colors.secondaryText,
//                       }}>
//                         {pkg.agentCustomerPrice ? `₵${pkg.agentCustomerPrice.toFixed(2)}` : '— (Uses Base)'}
//                       </span>
//                       {hasCustomerProfit && pkg.agentCustomerPrice && (
//                         <span style={{
//                           fontSize: isMobile ? '8px' : '10px',
//                           padding: isMobile ? '1px 6px' : '2px 8px',
//                           borderRadius: '10px',
//                           backgroundColor: '#10B98120',
//                           color: '#10B981',
//                           fontWeight: '700',
//                           display: 'inline-flex',
//                           alignItems: 'center',
//                           gap: '3px',
//                           width: 'fit-content',
//                         }}>
//                           <BadgeDollarSign size={isMobile ? 10 : 12} />
//                           Profit: ₵{customerProfit.toFixed(2)}
//                         </span>
//                       )}
//                       {pkg.agentCustomerPrice && !hasCustomerProfit && (
//                         <span style={{
//                           fontSize: isMobile ? '8px' : '10px',
//                           padding: isMobile ? '1px 6px' : '2px 8px',
//                           borderRadius: '10px',
//                           backgroundColor: '#EF444420',
//                           color: '#EF4444',
//                           fontWeight: '600',
//                           display: 'inline-flex',
//                           alignItems: 'center',
//                           gap: '3px',
//                           width: 'fit-content',
//                         }}>
//                           No profit
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                   <div>
//                     <div style={{
//                       fontSize: isMobile ? '7px' : '8px',
//                       color: colors.secondaryText,
//                       textTransform: 'uppercase'
//                     }}>
//                       Sub-Agent Base Price
//                     </div>
//                     <div style={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '1px',
//                     }}>
//                       <span style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         fontWeight: '700',
//                         color: pkg.agentSubBasePrice ? '#8B5CF6' : colors.secondaryText,
//                       }}>
//                         {pkg.agentSubBasePrice ? `₵${pkg.agentSubBasePrice.toFixed(2)}` : '— (Uses Base)'}
//                       </span>
//                       {hasSubAgentProfit && pkg.agentSubBasePrice && (
//                         <span style={{
//                           fontSize: isMobile ? '8px' : '10px',
//                           padding: isMobile ? '1px 6px' : '2px 8px',
//                           borderRadius: '10px',
//                           backgroundColor: '#8B5CF620',
//                           color: '#8B5CF6',
//                           fontWeight: '700',
//                           display: 'inline-flex',
//                           alignItems: 'center',
//                           gap: '3px',
//                           width: 'fit-content',
//                         }}>
//                           <BadgeDollarSign size={isMobile ? 10 : 12} />
//                           Profit: ₵{subAgentProfit.toFixed(2)}
//                         </span>
//                       )}
//                       {pkg.agentSubBasePrice && !hasSubAgentProfit && (
//                         <span style={{
//                           fontSize: isMobile ? '8px' : '10px',
//                           padding: isMobile ? '1px 6px' : '2px 8px',
//                           borderRadius: '10px',
//                           backgroundColor: '#EF444420',
//                           color: '#EF4444',
//                           fontWeight: '600',
//                           display: 'inline-flex',
//                           alignItems: 'center',
//                           gap: '3px',
//                           width: 'fit-content',
//                         }}>
//                           No profit
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Expand/Collapse for Sub-Agent Custom Prices */}
//                 {hasSubAgentCustomPrices && (
//                   <button
//                     onClick={() => toggleExpand(pkg.id)}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       padding: isMobile ? '2px 4px' : '3px 6px',
//                       background: 'none',
//                       border: 'none',
//                       cursor: 'pointer',
//                       color: colors.secondaryText,
//                       fontSize: isMobile ? '9px' : '11px',
//                       fontWeight: '500',
//                       width: '100%',
//                       borderTop: `1px solid ${colors.border}`,
//                       marginTop: '2px',
//                       paddingTop: isMobile ? '4px' : '6px',
//                     }}
//                   >
//                     <span>
//                       Sub-Agent Custom Prices ({subAgentCustomCount})
//                     </span>
//                     {isExpanded ? <ChevronUp size={isMobile ? 12 : 14} /> : <ChevronDown size={isMobile ? 12 : 14} />}
//                   </button>
//                 )}

//                 {isExpanded && hasSubAgentCustomPrices && (
//                   <div style={{
//                     padding: isMobile ? '4px 8px' : '6px 10px',
//                     backgroundColor: colors.mainBg,
//                     borderRadius: '6px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: '2px',
//                   }}>
//                     {Object.entries(pkg.agentSubCustomPrices).map(([username, price]) => {
//                       const customProfit = price ? price - pkg.basePriceAgent : null;
//                       const hasCustomProfit = customProfit !== null && customProfit > 0;
//                       return (
//                         <div
//                           key={username}
//                           style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             fontSize: isMobile ? '10px' : '12px',
//                             padding: isMobile ? '2px 0' : '3px 0',
//                             borderBottom: `1px solid ${colors.border}`,
//                           }}
//                         >
//                           <span style={{ color: colors.text }}>@{username}</span>
//                           <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '6px',
//                           }}>
//                             <span style={{
//                               fontWeight: '600',
//                               color: price ? '#F59E0B' : colors.secondaryText,
//                             }}>
//                               {price ? `₵${price.toFixed(2)}` : 'Uses Base'}
//                             </span>
//                             {hasCustomProfit && (
//                               <span style={{
//                                 fontSize: isMobile ? '7px' : '9px',
//                                 padding: isMobile ? '1px 6px' : '2px 6px',
//                                 borderRadius: '10px',
//                                 backgroundColor: '#10B98120',
//                                 color: '#10B981',
//                                 fontWeight: '600',
//                                 display: 'inline-flex',
//                                 alignItems: 'center',
//                                 gap: '2px',
//                               }}>
//                                 <BadgeDollarSign size={isMobile ? 8 : 10} />
//                                 ₵{customProfit.toFixed(2)}
//                               </span>
//                             )}
//                             {price && !hasCustomProfit && (
//                               <span style={{
//                                 fontSize: isMobile ? '7px' : '9px',
//                                 padding: isMobile ? '1px 6px' : '2px 6px',
//                                 borderRadius: '10px',
//                                 backgroundColor: '#EF444420',
//                                 color: '#EF4444',
//                                 fontWeight: '600',
//                               }}>
//                                 No profit
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}

//                 {/* Action Buttons */}
//                 <div style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   gap: isMobile ? '4px' : '6px',
//                   marginTop: '2px',
//                 }}>


//                   {/* <button
//                     onClick={() => handleEditPrice(pkg, 'customer')}
//                     style={{
//                       padding: isMobile ? '4px 8px' : '5px 10px',
//                       borderRadius: '6px',
//                       border: `1px solid ${colors.btnBg}`,
//                       backgroundColor: 'transparent',
//                       color: colors.btnBg,
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '9px' : '11px',
//                       fontWeight: '500',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '3px',
//                       transition: 'all 0.2s',
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = colors.btnBg;
//                       e.currentTarget.style.color = colors.btnText;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = 'transparent';
//                       e.currentTarget.style.color = colors.btnBg;
//                     }}
//                   >
//                     <Edit2 size={isMobile ? 11 : 13} />
//                     {!isMobile && 'Edit Customer'}
//                     {isMobile && 'Customer'}
//                   </button>
//                   <button
//                     onClick={() => handleEditPrice(pkg, 'subAgent')}
//                     style={{
//                       padding: isMobile ? '4px 8px' : '5px 10px',
//                       borderRadius: '6px',
//                       border: `1px solid #8B5CF6`,
//                       backgroundColor: 'transparent',
//                       color: '#8B5CF6',
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '9px' : '11px',
//                       fontWeight: '500',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '3px',
//                       transition: 'all 0.2s',
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = '#8B5CF6';
//                       e.currentTarget.style.color = 'white';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = 'transparent';
//                       e.currentTarget.style.color = '#8B5CF6';
//                     }}
//                   >
//                     <Edit2 size={isMobile ? 11 : 13} />
//                     {!isMobile && 'Edit Sub-Agent'}
//                     {isMobile && 'Sub-Agent'}
//                   </button> */}

//                   <button
//                     onClick={() => openEditModal(pkg, 'customer')}
//                     style={{
//                       padding: isMobile ? '4px 8px' : '5px 10px',
//                       borderRadius: '6px',
//                       border: `1px solid ${colors.btnBg}`,
//                       backgroundColor: 'transparent',
//                       color: colors.btnBg,
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '9px' : '11px',
//                       fontWeight: '500',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '3px',
//                       transition: 'all 0.2s',
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = colors.btnBg;
//                       e.currentTarget.style.color = colors.btnText;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = 'transparent';
//                       e.currentTarget.style.color = colors.btnBg;
//                     }}
//                   >
//                     <Edit2 size={isMobile ? 11 : 13} />
//                     {!isMobile && 'Edit Customer'}
//                     {isMobile && 'Customer'}
//                   </button>

//                   <button
//                     onClick={() => openEditModal(pkg, 'subAgent')}
//                     style={{
//                       padding: isMobile ? '4px 8px' : '5px 10px',
//                       borderRadius: '6px',
//                       border: `1px solid #8B5CF6`,
//                       backgroundColor: 'transparent',
//                       color: '#8B5CF6',
//                       cursor: 'pointer',
//                       fontSize: isMobile ? '9px' : '11px',
//                       fontWeight: '500',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       gap: '3px',
//                       transition: 'all 0.2s',
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = '#8B5CF6';
//                       e.currentTarget.style.color = 'white';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = 'transparent';
//                       e.currentTarget.style.color = '#8B5CF6';
//                     }}
//                   >
//                     <Edit2 size={isMobile ? 11 : 13} />
//                     {!isMobile && 'Edit Sub-Agent'}
//                     {isMobile && 'Sub-Agent'}
//                   </button>

//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {filteredPackages.length === 0 && (
//           <div style={{
//             textAlign: 'center',
//             padding: isMobile ? '20px 16px' : '30px 20px',
//             color: colors.secondaryText,
//             backgroundColor: colors.raisedBg,
//             borderRadius: '10px',
//             border: `1px solid ${colors.border}`,
//           }}>
//             <Package size={isMobile ? 24 : 32} style={{ opacity: 0.3, marginBottom: '8px' }} />
//             <div style={{ fontSize: isMobile ? '13px' : '14px' }}>No packages found matching your criteria</div>
//           </div>
//         )}
//       </div>

//       {/* Edit Price Modal */}
//       {showEditModal && editingPackage && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             backdropFilter: 'blur(4px)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 1000,
//             padding: '16px',
//             animation: 'fadeIn 0.2s ease',
//           }}
//           onClick={(e) => {
//             if (e.target === e.currentTarget) {
//               setShowEditModal(false);
//               setEditingPackage(null);
//               setNewPrice('');
//             }
//           }}
//         >
//           <div style={{
//             backgroundColor: colors.raisedBg,
//             borderRadius: isMobile ? '14px' : '16px',
//             maxWidth: '400px',
//             width: '100%',
//             padding: isMobile ? '16px 18px 20px' : '20px 24px 24px',
//             boxShadow: `0 20px 60px ${colors.shadow}`,
//             animation: 'slideUp 0.25s ease',
//             boxSizing: 'border-box',
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               marginBottom: isMobile ? '12px' : '16px',
//             }}>
//               <h3 style={{
//                 fontSize: isMobile ? '15px' : '17px',
//                 fontWeight: '700',
//                 color: colors.heading,
//                 margin: 0,
//               }}>
//                 {editingType === 'customer' ? 'Edit Customer Price' : 'Edit Sub-Agent Base Price'}
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowEditModal(false);
//                   setEditingPackage(null);
//                   setNewPrice('');
//                 }}
//                 style={{
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: colors.secondaryText,
//                   padding: '4px',
//                   borderRadius: '4px',
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//               >
//                 <X size={isMobile ? 18 : 20} />
//               </button>
//             </div>

//             <div style={{ marginBottom: isMobile ? '10px' : '14px' }}>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '6px',
//                 marginBottom: '4px',
//                 flexWrap: 'wrap',
//               }}>
//                 <span style={{
//                   fontSize: isMobile ? '10px' : '12px',
//                   fontWeight: '600',
//                   color: getNetworkColor(editingPackage.network),
//                   textTransform: 'uppercase',
//                 }}>
//                   {editingPackage.network}
//                 </span>
//                 <span style={{ color: colors.secondaryText }}>•</span>
//                 <span style={{
//                   fontSize: isMobile ? '13px' : '15px',
//                   fontWeight: '700',
//                   color: colors.heading,
//                 }}>
//                   {editingPackage.size}
//                 </span>
//               </div>
//               <div style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '2px',
//                 fontSize: isMobile ? '10px' : '12px',
//                 color: colors.secondaryText,
//               }}>
//                 <span>Base Agent Price: <strong style={{ color: colors.text }}>₵{editingPackage.basePriceAgent.toFixed(2)}</strong></span>
//                 {editingType === 'customer' ? (
//                   <>
//                     <span>Current Customer Price: <strong style={{ color: colors.btnBg }}>
//                       {editingPackage.agentCustomerPrice ? `₵${editingPackage.agentCustomerPrice.toFixed(2)}` : 'Not Set (Uses Base)'}
//                     </strong></span>
//                     <span>Current Profit: <strong style={{ color: '#10B981' }}>
//                       {editingPackage.agentCustomerPrice ? `₵${(editingPackage.agentCustomerPrice - editingPackage.basePriceAgent).toFixed(2)}` : 'N/A'}
//                     </strong></span>
//                   </>
//                 ) : (
//                   <>
//                     <span>Current Sub-Agent Base Price: <strong style={{ color: '#8B5CF6' }}>
//                       {editingPackage.agentSubBasePrice ? `₵${editingPackage.agentSubBasePrice.toFixed(2)}` : 'Not Set (Uses Base)'}
//                     </strong></span>
//                     <span>Current Profit: <strong style={{ color: '#10B981' }}>
//                       {editingPackage.agentSubBasePrice ? `₵${(editingPackage.agentSubBasePrice - editingPackage.basePriceAgent).toFixed(2)}` : 'N/A'}
//                     </strong></span>
//                   </>
//                 )}
//               </div>
//               <div style={{
//                 marginTop: '4px',
//                 padding: '4px 8px',
//                 borderRadius: '4px',
//                 backgroundColor: colors.mainBg,
//                 fontSize: isMobile ? '9px' : '11px',
//                 color: colors.secondaryText,
//               }}>
//                 <strong>Note:</strong> Cannot set price below Base Agent Price (₵{editingPackage.basePriceAgent.toFixed(2)})
//               </div>
//             </div>

//             <div style={{ marginBottom: isMobile ? '12px' : '16px' }}>
//               <label style={{
//                 display: 'block',
//                 fontSize: isMobile ? '11px' : '13px',
//                 fontWeight: '600',
//                 color: colors.text,
//                 marginBottom: '4px',
//               }}>
//                 New {editingType === 'customer' ? 'Customer' : 'Sub-Agent Base'} Price
//               </label>
//               <div style={{
//                 position: 'relative',
//               }}>
//                 <span style={{
//                   position: 'absolute',
//                   left: '10px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   color: colors.secondaryText,
//                   fontWeight: '600',
//                   fontSize: isMobile ? '13px' : '15px',
//                 }}>
//                   ₵
//                 </span>
//                 <input
//                   type="number"
//                   value={newPrice}
//                   onChange={(e) => setNewPrice(e.target.value)}
//                   min={editingPackage.basePriceAgent}
//                   step="0.01"
//                   placeholder={`Min: ₵${editingPackage.basePriceAgent.toFixed(2)}`}
//                   style={{
//                     width: '100%',
//                     padding: isMobile ? '7px 10px 7px 26px' : '9px 12px 9px 30px',
//                     borderRadius: '8px',
//                     border: `1.5px solid ${colors.border}`,
//                     backgroundColor: colors.raisedBg,
//                     color: colors.text,
//                     fontSize: isMobile ? '13px' : '15px',
//                     outline: 'none',
//                     transition: 'border-color 0.2s',
//                     boxSizing: 'border-box',
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = colors.btnBg}
//                   onBlur={(e) => e.target.style.borderColor = colors.border}
//                   autoFocus
//                 />
//               </div>
//               <div style={{
//                 fontSize: isMobile ? '9px' : '11px',
//                 color: colors.secondaryText,
//                 marginTop: '2px',
//               }}>
//                 {editingType === 'customer' ? (
//                   <>New profit per sale: ₵{newPrice ? (Number(newPrice) - editingPackage.basePriceAgent).toFixed(2) : '0.00'}</>
//                 ) : (
//                   <>Sub-agent's base price • Your profit: ₵{newPrice ? (Number(newPrice) - editingPackage.basePriceAgent).toFixed(2) : '0.00'}</>
//                 )}
//               </div>
//             </div>

//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: '1fr 1.5fr',
//               gap: isMobile ? '6px' : '10px',
//             }}>
//               <button
//                 onClick={() => {
//                   setShowEditModal(false);
//                   setEditingPackage(null);
//                   setNewPrice('');
//                 }}
//                 style={{
//                   padding: isMobile ? '7px' : '9px',
//                   borderRadius: '8px',
//                   border: `1.5px solid ${colors.border}`,
//                   backgroundColor: 'transparent',
//                   color: colors.text,
//                   cursor: 'pointer',
//                   fontWeight: '500',
//                   fontSize: isMobile ? '11px' : '13px',
//                   transition: 'all 0.2s',
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSavePrice}
//                 disabled={isSubmitting}
//                 style={{
//                   padding: isMobile ? '7px' : '9px',
//                   borderRadius: '8px',
//                   border: 'none',
//                   backgroundColor: editingType === 'customer' ? colors.btnBg : '#8B5CF6',
//                   color: '#fff',
//                   cursor: isSubmitting ? 'not-allowed' : 'pointer',
//                   fontWeight: '600',
//                   fontSize: isMobile ? '11px' : '13px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: '4px',
//                   transition: 'all 0.2s',
//                   opacity: isSubmitting ? 0.7 : 1,
//                 }}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <div className="spinner-small" style={{
//                       width: '12px',
//                       height: '12px',
//                       border: `2px solid #fff40`,
//                       borderTop: `2px solid #fff`,
//                       borderRadius: '50%',
//                       animation: 'spin 0.8s linear infinite',
//                     }} />
//                     Saving...
//                   </>
//                 ) : (
//                   <>
//                     <Save size={isMobile ? 14 : 16} />
//                     Save
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes slideUp {
//           from { 
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to { 
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         * {
//           box-sizing: border-box;
//         }
//       `}</style>
//     </div>
//   );
// };

// // Helper function for status label
// const getStatusLabel = (status) => {
//   if (!status) return 'N/A';
//   return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
// };

// const StatCard = ({ icon, label, value, change, positive, color, colors, isMobile }) => (
//   <div style={{
//     backgroundColor: colors.raisedBg,
//     borderRadius: isMobile ? '8px' : '12px',
//     padding: isMobile ? '8px 10px' : '14px 16px',
//     border: `1px solid ${colors.border}`,
//     transition: 'all 0.3s ease',
//     width: '100%',
//     minWidth: 0,
//     maxWidth: '100%',
//     boxSizing: 'border-box',
//     overflow: 'hidden',
//   }}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.transform = 'translateY(-3px)';
//       e.currentTarget.style.boxShadow = `0 6px 20px ${colors.shadow}`;
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = 'none';
//     }}>
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       marginBottom: isMobile ? '2px' : '3px',
//       minWidth: 0,
//       gap: '4px',
//     }}>
//       <span style={{
//         fontSize: isMobile ? '8px' : '11px',
//         color: colors.secondaryText,
//         fontWeight: '500',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         flex: 1,
//       }}>
//         {label}
//       </span>
//       <span style={{
//         color: color,
//         opacity: 0.7,
//         display: 'flex',
//         alignItems: 'center',
//         flexShrink: 0,
//       }}>
//         {icon}
//       </span>
//     </div>
//     <div style={{
//       fontSize: isMobile ? 'clamp(13px, 3.5vw, 18px)' : 'clamp(18px, 2vw, 22px)',
//       fontWeight: '700',
//       color: colors.heading,
//       overflow: 'hidden',
//       textOverflow: 'ellipsis',
//       whiteSpace: 'nowrap',
//       maxWidth: '100%',
//     }}>
//       {value}
//     </div>
//     {change && (
//       <div style={{
//         fontSize: isMobile ? '7px' : '10px',
//         color: positive ? '#10B981' : '#EF4444',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '2px',
//         marginTop: isMobile ? '1px' : '2px',
//         overflow: 'hidden',
//       }}>
//         {positive ? <ArrowUp size={isMobile ? 10 : 12} /> : <ArrowDown size={isMobile ? 10 : 12} />}
//         <span style={{
//           overflow: 'hidden',
//           textOverflow: 'ellipsis',
//           whiteSpace: 'nowrap',
//           flex: 1,
//         }}>
//           {change}
//         </span>
//       </div>
//     )}
//   </div>
// );

// const QuickStat = ({ label, value, icon, color, colors, isMobile }) => (
//   <div style={{
//     backgroundColor: colors.raisedBg,
//     borderRadius: isMobile ? '6px' : '10px',
//     padding: isMobile ? '5px 8px' : '10px 14px',
//     border: `1px solid ${colors.border}`,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     width: '100%',
//     minWidth: 0,
//     maxWidth: '100%',
//     boxSizing: 'border-box',
//     overflow: 'hidden',
//     gap: '4px',
//   }}>
//     <div style={{
//       minWidth: 0,
//       flex: 1,
//       overflow: 'hidden',
//     }}>
//       <div style={{
//         fontSize: isMobile ? '7px' : '10px',
//         color: colors.secondaryText,
//         fontWeight: '500',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//       }}>
//         {label}
//       </div>
//       <div style={{
//         fontSize: isMobile ? 'clamp(11px, 3vw, 16px)' : '15px',
//         fontWeight: '700',
//         color: colors.heading,
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//       }}>
//         {value}
//       </div>
//     </div>
//     <span style={{
//       color: color,
//       opacity: 0.6,
//       display: 'flex',
//       alignItems: 'center',
//       flexShrink: 0,
//     }}>
//       {icon}
//     </span>
//   </div>
// );

// export default AgentDashboard;


































// screens/agent/AgentDashboard.jsx
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTheme } from "../../hooks/useTheme";
import { useAuth } from "../../providers/AuthProvider";
import { useToast } from "../../providers/ToastProvider";
import { useNavigate } from "react-router-dom";
import {
  Wallet,
  TrendingUp,
  Users,
  Edit2,
  Save,
  X,
  Package,
  Clock,
  CheckCircle,
  RefreshCw,
  Search,
  AlertCircle,
  Info,
  ChevronDown,
  ChevronUp,
  BarChart3,
  Activity,
  Zap,
  ShoppingBag,
  UserPlus,
  ArrowUp,
  ArrowDown,
  ChevronRight,
  Coins,
  Trash2,
  BadgeDollarSign,
} from "lucide-react";

/* ══════════════════════════════════════════════════════════
   Pricing system reference (mental model):
   ─────────────────────────────────────────────────────────
   base_price_agent       — admin floor. Never sell below.
   base_price_customer    — admin suggested retail (fallback)
   agent_customer_price   — price agent charges walk-in customers
   agent_sub_base_price   — price agent charges their sub-agents
   agent_sub_custom_prices — { subUsername: price } overrides
   profit = sellingPrice − base_price_agent
   ══════════════════════════════════════════════════════════ */

// Maps price_source (from API) to a display badge. All fg/bg values are
// resolved at render time from the theme so dark mode works cleanly.
const PRICE_SOURCE_KEYS = {
  admin_custom: { label: "Admin Special", tone: "info" },
  agent_custom: { label: "Your Price", tone: "success" },
  agent_sub_custom: { label: "Sub-Agent Custom", tone: "warning" },
  sub_agent_custom: { label: "Sub-Agent Price", tone: "purple" },
  agent_base: { label: "Agent Base", tone: "warning" },
  base: { label: "Base Price", tone: "muted" },
};

const NETWORK_KEYS = {
  MTN: { label: "MTN", dot: "#F5B700" },
  Telecel: { label: "Telecel", dot: "#E11D48" },
  AirtelTigo: { label: "AirtelTigo", dot: "#2563EB" },
  AT_BIGTIME: { label: "AT BigTime", dot: "#2563EB" },
  MTN_EXPRESS: { label: "MTN Express", dot: "#F5B700" },
};

const getNetworkMeta = (network) =>
  NETWORK_KEYS[network] || { label: network || "Unknown", dot: "#6B7280" };

const getToneColors = (colors, tone) => {
  const map = {
    success: { fg: colors.success, bg: colors.successBg },
    warning: { fg: colors.warning, bg: colors.warningBg },
    error: { fg: colors.error, bg: colors.errorBg },
    info: { fg: colors.linkColor, bg: colors.hoverBg },
    purple: { fg: colors.linkColor, bg: colors.hoverBg },
    muted: { fg: colors.secondaryText, bg: colors.hoverBg },
  };
  return map[tone] || map.muted;
};

const readApiError = (data, fallback = "Request failed") => {
  if (!data) return fallback;
  if (data.message) return data.message;
  const errs = data.errors;
  if (errs) {
    const flat = Object.values(errs).flat().filter(Boolean);
    if (flat.length) return flat.join(" ");
  }
  return fallback;
};

const formatDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
};

/* ══════════════════════════════════════════════════════════
   Main component
   ══════════════════════════════════════════════════════════ */

export default function AgentDashboard() {
  const { colors } = useTheme();
  const { user, authFetch } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [packages, setPackages] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("ALL");
  const [expandedPackages, setExpandedPackages] = useState({});
  const [activeChartTab, setActiveChartTab] = useState("revenue");
  const [animating, setAnimating] = useState(false);

  // Sub-agent fee
  const [subAgentFee, setSubAgentFee] = useState(null);
  const [editingFee, setEditingFee] = useState(false);
  const [feeInput, setFeeInput] = useState("");
  const [savingFee, setSavingFee] = useState(false);
  const [resettingFee, setResettingFee] = useState(false);

  // Price edit modal
  const [editingPackage, setEditingPackage] = useState(null);
  const [editingType, setEditingType] = useState("customer");
  const [priceInput, setPriceInput] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const chartAnimTimer = useRef(null);

  const isMobile = width <= 768;

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ── Loaders ─────────────────────────────────────────────
  const fetchSubAgentFee = useCallback(async () => {
    try {
      const res = await authFetch("/accounts/agent/sub-agent-fee/");
      const data = await res.json();
      if (res.ok && data.status === "success") {
        setSubAgentFee(data.data);
        setFeeInput(data.data?.current_fee || "");
      }
    } catch (err) {
      console.error("fetchSubAgentFee:", err);
    }
  }, [authFetch]);

  const fetchDashboardData = useCallback(
    async ({ silent } = {}) => {
      if (!silent) setLoading(true);
      else setRefreshing(true);
      setAnimating(false);
      if (chartAnimTimer.current) clearTimeout(chartAnimTimer.current);

      try {
        const [profileRes, statsRes, pkgRes] = await Promise.all([
          authFetch("/accounts/user/me/"),
          authFetch("/accounts/dashboard/stats/"),
          authFetch("/data/packages/"),
        ]);
        const [profile, stats, pkgData] = await Promise.all([
          profileRes.json(),
          statsRes.json(),
          pkgRes.json(),
        ]);

        if (profileRes.ok && profile.status === "success") {
          setWalletBalance(parseFloat(profile.data.wallet?.balance || 0));
        }
        if (statsRes.ok && stats.status === "success") {
          setDashboardData(stats.data);
        }
        if (pkgRes.ok && pkgData.status === "success") {
          setPackages(
            (pkgData.data || []).map((p) => ({
              id: p.id,
              network: p.network,
              size: `${p.size_gb}GB`,
              sizeGb: parseFloat(p.size_gb || 0),
              basePriceCustomer: parseFloat(p.base_price_customer || 0),
              basePriceAgent: parseFloat(p.base_price_agent || 0),
              effectivePrice: parseFloat(
                p.effective_price ||
                  p.base_price_agent ||
                  p.base_price_customer ||
                  0
              ),
              priceSource: p.price_source || "base",
              agentCustomerPrice: p.agent_customer_price
                ? parseFloat(p.agent_customer_price)
                : null,
              agentSubBasePrice: p.agent_sub_base_price
                ? parseFloat(p.agent_sub_base_price)
                : null,
              agentSubCustomPrices: p.agent_sub_custom_prices || {},
              isActive: p.is_active,
              salesCount: p.sales_count || 0,
            }))
          );
        }

        await fetchSubAgentFee();
      } catch (err) {
        console.error("fetchDashboardData:", err);
        showToast("Failed to load dashboard data", "error");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [authFetch, fetchSubAgentFee, showToast]
  );

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  // Kick off chart animation after data arrives
  useEffect(() => {
    if (dashboardData) {
      chartAnimTimer.current = setTimeout(() => setAnimating(true), 250);
    }
    return () => {
      if (chartAnimTimer.current) clearTimeout(chartAnimTimer.current);
    };
  }, [dashboardData]);

  // ── Sub-agent fee ───────────────────────────────────────
  const handleSaveFee = async () => {
    const fee = parseFloat(feeInput);
    if (isNaN(fee) || fee <= 0) {
      showToast("Enter a valid positive number", "error");
      return;
    }
    if (subAgentFee?.base_fee && fee < parseFloat(subAgentFee.base_fee)) {
      showToast(
        `Fee cannot be below base (₵${subAgentFee.base_fee})`,
        "error"
      );
      return;
    }
    setSavingFee(true);
    try {
      const method = subAgentFee?.is_custom ? "PATCH" : "PUT";
      const res = await authFetch("/accounts/agent/sub-agent-fee/", {
        method,
        body: JSON.stringify({ fee: fee.toFixed(2) }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(readApiError(data, "Failed to update fee"));
      showToast(data.message || "Fee updated", "success");
      setSubAgentFee(data.data);
      setEditingFee(false);
      fetchDashboardData({ silent: true });
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setSavingFee(false);
    }
  };

  const handleResetFee = async () => {
    if (!window.confirm("Reset to base fee?")) return;
    setResettingFee(true);
    try {
      const res = await authFetch(
        "/accounts/agent/sub-agent-fee/reset/",
        { method: "DELETE" }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(readApiError(data, "Failed to reset"));
      showToast(data.message || "Custom fee removed", "success");
      await fetchSubAgentFee();
      fetchDashboardData({ silent: true });
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setResettingFee(false);
    }
  };

  // ── Price editing ───────────────────────────────────────
  const openPriceModal = (pkg, type) => {
    setEditingPackage(pkg);
    setEditingType(type);
    setPriceInput(
      type === "customer"
        ? String(pkg.agentCustomerPrice || pkg.effectivePrice || pkg.basePriceAgent)
        : String(pkg.agentSubBasePrice || pkg.basePriceAgent)
    );
  };

  const closePriceModal = () => {
    setEditingPackage(null);
    setPriceInput("");
    setEditingType("customer");
  };

  const savePrice = async () => {
    if (!editingPackage) return;
    const value = Number(priceInput);
    if (!priceInput || isNaN(value) || value <= 0) {
      showToast("Enter a valid price", "error");
      return;
    }
    if (value < editingPackage.basePriceAgent) {
      showToast(
        `Price cannot be below base (₵${editingPackage.basePriceAgent.toFixed(2)})`,
        "error"
      );
      return;
    }

    setSubmitting(true);
    try {
      const priceType =
        editingType === "customer"
          ? "AGENT_CUSTOMER_PRICE"
          : "AGENT_SUB_BASE_PRICE";
      const isEditing =
        editingType === "customer"
          ? editingPackage.agentCustomerPrice !== null
          : editingPackage.agentSubBasePrice !== null;

      let res;
      if (isEditing) {
        const listRes = await authFetch(
          `/data/pricing/?package=${editingPackage.id}&user=${user.id}`
        );
        const listData = await listRes.json();
        const existing =
          listRes.ok && listData.status === "success"
            ? (listData.data || [])[0]
            : null;

        if (existing) {
          res = await authFetch(`/data/pricing/${existing.id}/`, {
            method: "PATCH",
            body: JSON.stringify({
              price: priceInput,
              notes: `Updated ${editingType} price for ${editingPackage.network} ${editingPackage.size}`,
            }),
          });
        }
      }
      if (!res) {
        res = await authFetch("/data/pricing/create/", {
          method: "POST",
          body: JSON.stringify({
            package: editingPackage.id,
            user: user.id,
            price_type: priceType,
            price: priceInput,
            notes: `${editingType === "customer" ? "Customer" : "Sub-Agent"} price for ${editingPackage.network} ${editingPackage.size}`,
          }),
        });
      }

      const data = await res.json();
      if (!res.ok) throw new Error(readApiError(data, "Failed to save price"));
      showToast("Price saved", "success");
      closePriceModal();
      fetchDashboardData({ silent: true });
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  // ── Derived data ────────────────────────────────────────
  const agentStats = dashboardData?.agent || {};
  const totalRevenue = parseFloat(agentStats.total_revenue || 0);
  const totalProfit = parseFloat(agentStats.total_profit || 0);
  const totalOrders = agentStats.total_orders || 0;
  const totalSubAgents = agentStats.total_sub_agents || 0;
  const pendingOrders = dashboardData?.pending_orders || 0;
  const completedOrders = agentStats.completed_orders || 0;
  const shopName = agentStats.shop_name || "My Store";
  const storeUrl = agentStats.store_url || "";

  const chartData = useMemo(() => {
    const weekly = dashboardData?.agent?.weekly;
    if (!weekly) return null;
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const pick = (series) =>
      days.map((day) => {
        const hit = series?.find((r) => r.day === day);
        return hit ? hit.value : 0;
      });
    return {
      labels: days,
      revenue: pick(weekly.revenue),
      profit: pick(weekly.profit),
      orders: pick(weekly.orders),
      summary: weekly.summary || {},
    };
  }, [dashboardData]);

  const filteredPackages = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return packages.filter((p) => {
      if (!p.isActive) return false;
      if (selectedNetwork !== "ALL" && p.network !== selectedNetwork)
        return false;
      if (q && !`${p.network} ${p.size}`.toLowerCase().includes(q))
        return false;
      return true;
    });
  }, [packages, selectedNetwork, searchQuery]);

  // ── Loading ─────────────────────────────────────────────
  if (loading) {
    return (
      <div style={styles.loadingWrap(colors)}>
        <div style={styles.spinner(colors)} />
        <span style={{ fontSize: 13, color: colors.secondaryText }}>
          Loading dashboard…
        </span>
      </div>
    );
  }

  return (
    <div style={styles.pageWrap}>
      {/* ── Header ──────────────────────────────────────── */}
      <header style={styles.header}>
        <div style={{ minWidth: 0 }}>
          <h1 style={styles.h1(colors)}>
            <Activity size={isMobile ? 20 : 22} color={colors.btnBg} />
            Agent dashboard
          </h1>
          <p style={styles.subtitle(colors)}>
            Welcome back, {user?.first_name || user?.username || "Agent"}
            {shopName ? ` · ${shopName}` : ""}
            {storeUrl ? ` · ${storeUrl}.azoeshop.store` : ""}
          </p>
        </div>
        <button
          type="button"
          onClick={() => fetchDashboardData({ silent: true })}
          disabled={refreshing}
          style={styles.ghostBtn(colors)}
        >
          <RefreshCw
            size={14}
            style={{
              animation: refreshing ? "spin 1s linear infinite" : "none",
            }}
          />
          {!isMobile && (refreshing ? "Refreshing…" : "Refresh")}
        </button>
      </header>

      {/* ── Stat grid ──────────────────────────────────── */}
      <section style={styles.statGrid}>
        <StatCard
          icon={TrendingUp}
          label="Revenue"
          value={`₵${totalRevenue.toFixed(2)}`}
          change="All time"
          color={colors.btnBg}
          colors={colors}
        />
        <StatCard
          icon={BadgeDollarSign}
          label="Profit"
          value={`₵${totalProfit.toFixed(2)}`}
          change="All time"
          color={colors.success}
          colors={colors}
        />
        <StatCard
          icon={ShoppingBag}
          label="Orders"
          value={totalOrders}
          change={`${pendingOrders} pending`}
          color={colors.warning}
          colors={colors}
        />
        <StatCard
          icon={Users}
          label="Sub-agents"
          value={totalSubAgents}
          change="Active"
          color={colors.linkColor}
          colors={colors}
        />
      </section>

      {/* ── Sub-agent fee ──────────────────────────────── */}
      {subAgentFee && (
        <FeeCard
          fee={subAgentFee}
          editing={editingFee}
          feeInput={feeInput}
          setFeeInput={setFeeInput}
          saving={savingFee}
          resetting={resettingFee}
          onEdit={() => {
            setEditingFee(true);
            setFeeInput(subAgentFee?.current_fee || "");
          }}
          onCancel={() => {
            setEditingFee(false);
            setFeeInput(subAgentFee?.current_fee || "");
          }}
          onSave={handleSaveFee}
          onReset={handleResetFee}
          colors={colors}
          isMobile={isMobile}
        />
      )}

      {/* ── Mini stats ─────────────────────────────────── */}
      <section style={styles.miniStatGrid}>
        <MiniStat
          icon={Wallet}
          label="Wallet"
          value={`₵${walletBalance.toFixed(2)}`}
          color={colors.linkColor}
          colors={colors}
        />
        <MiniStat
          icon={CheckCircle}
          label="Completed"
          value={completedOrders}
          color={colors.success}
          colors={colors}
        />
        <MiniStat
          icon={UserPlus}
          label="Sub sales"
          value={agentStats.transactions_from_shop || 0}
          color={colors.linkColor}
          colors={colors}
        />
        <MiniStat
          icon={BarChart3}
          label="Revenue"
          value={`₵${totalRevenue.toFixed(2)}`}
          color={colors.btnBg}
          colors={colors}
        />
      </section>

      {/* ── Chart ──────────────────────────────────────── */}
      {chartData && (
        <Card colors={colors}>
          <div style={styles.cardHeader}>
            <div style={styles.cardTitleRow}>
              <BarChart3 size={16} color={colors.btnBg} />
              <span style={styles.cardTitle(colors)}>Performance</span>
              <span style={styles.cardSubtitle(colors)}>Last 7 days</span>
            </div>
            <div style={styles.segmented(colors)}>
              {["revenue", "profit", "orders"].map((tab) => (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveChartTab(tab)}
                  style={styles.segmentBtn(colors, activeChartTab === tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
          <WeeklyChart
            data={chartData}
            activeTab={activeChartTab}
            animating={animating}
            colors={colors}
            isMobile={isMobile}
          />
        </Card>
      )}

      {/* ── Recent orders ─────────────────────────────── */}
      {dashboardData?.agent?.recent_orders?.length > 0 && (
        <Card colors={colors}>
          <div style={styles.cardHeader}>
            <div style={styles.cardTitleRow}>
              <Clock size={16} color={colors.btnBg} />
              <span style={styles.cardTitle(colors)}>Recent orders</span>
            </div>
            <button
              type="button"
              onClick={() => navigate("/orders")}
              style={styles.linkBtn(colors)}
            >
              View all <ChevronRight size={13} />
            </button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  {["Order", "Customer", "Amount", "Status"].map((h) => (
                    <th key={h} style={styles.th(colors)}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dashboardData.agent.recent_orders.slice(0, 6).map((o) => (
                  <tr key={o.id} style={styles.tr(colors)}>
                    <td style={styles.td(colors)}>
                      <span style={styles.mono(colors)}>
                        #{o.id?.slice(0, 8) || "N/A"}
                      </span>
                    </td>
                    <td style={styles.td(colors)}>{o.customer || "—"}</td>
                    <td style={styles.td(colors)}>
                      <strong style={{ color: colors.heading }}>
                        ₵{Number(o.amount || 0).toFixed(2)}
                      </strong>
                    </td>
                    <td style={styles.td(colors)}>
                      <OrderStatusPill status={o.status} colors={colors} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}

      {/* ── Packages ──────────────────────────────────── */}
      <Card colors={colors}>
        <div style={styles.cardHeader}>
          <div style={styles.cardTitleRow}>
            <Package size={16} color={colors.btnBg} />
            <span style={styles.cardTitle(colors)}>My packages</span>
            <span style={styles.chip(colors)}>{packages.length}</span>
          </div>
        </div>

        {/* Filters */}
        <div style={styles.filtersRow}>
          <div style={styles.searchWrap}>
            <Search size={14} color={colors.secondaryText} style={styles.searchIcon} />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search packages…"
              style={styles.searchInput(colors)}
            />
            {searchQuery && (
              <button
                type="button"
                onClick={() => setSearchQuery("")}
                style={styles.searchClear}
                aria-label="Clear"
              >
                <X size={13} />
              </button>
            )}
          </div>
          <div style={styles.networkChips}>
            {["ALL", "MTN", "Telecel", "AirtelTigo"].map((n) => {
              const meta = n === "ALL" ? null : getNetworkMeta(n);
              const active = selectedNetwork === n;
              return (
                <button
                  key={n}
                  type="button"
                  onClick={() => setSelectedNetwork(n)}
                  style={styles.networkChip(colors, active)}
                >
                  {meta && (
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: meta.dot,
                        flexShrink: 0,
                      }}
                    />
                  )}
                  {n === "ALL" ? "All" : meta?.label || n}
                </button>
              );
            })}
          </div>
        </div>

        {filteredPackages.length === 0 ? (
          <div style={styles.emptyState(colors)}>
            <Package size={28} color={colors.secondaryText} />
            <p style={{ margin: "10px 0 0", fontSize: 13 }}>
              No packages match your filters.
            </p>
          </div>
        ) : (
          <div style={styles.pkgGrid}>
            {filteredPackages.map((pkg) => (
              <PackageCard
                key={pkg.id}
                pkg={pkg}
                colors={colors}
                isMobile={isMobile}
                expanded={!!expandedPackages[pkg.id]}
                onToggle={() =>
                  setExpandedPackages((prev) => ({
                    ...prev,
                    [pkg.id]: !prev[pkg.id],
                  }))
                }
                onEditCustomer={() => openPriceModal(pkg, "customer")}
                onEditSubAgent={() => openPriceModal(pkg, "subAgent")}
              />
            ))}
          </div>
        )}
      </Card>

      {/* ── Price modal ───────────────────────────────── */}
      {editingPackage && (
        <PriceModal
          pkg={editingPackage}
          type={editingType}
          priceInput={priceInput}
          setPriceInput={setPriceInput}
          submitting={submitting}
          onClose={closePriceModal}
          onSave={savePrice}
          colors={colors}
          isMobile={isMobile}
        />
      )}

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════
   Sub-components
   ══════════════════════════════════════════════════════════ */

const Card = ({ colors, children }) => (
  <div style={styles.card(colors)}>{children}</div>
);

const StatCard = ({ icon: Icon, label, value, change, color, colors }) => (
  <div style={styles.statCard(colors)}>
    <div style={styles.statTop}>
      <span style={styles.statLabel(colors)}>{label}</span>
      <span
        style={{
          width: 30,
          height: 30,
          borderRadius: 9,
          background: colors.hoverBg,
          color,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon size={15} />
      </span>
    </div>
    <div style={styles.statValue(colors)}>{value}</div>
    {change && <div style={styles.statChange(colors)}>{change}</div>}
  </div>
);

const MiniStat = ({ icon: Icon, label, value, color, colors }) => (
  <div style={styles.miniStat(colors)}>
    <span
      style={{
        width: 28,
        height: 28,
        borderRadius: 8,
        background: colors.hoverBg,
        color,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Icon size={14} />
    </span>
    <div style={{ minWidth: 0, flex: 1 }}>
      <div style={styles.miniStatLabel(colors)}>{label}</div>
      <div style={styles.miniStatValue(colors)}>{value}</div>
    </div>
  </div>
);

const FeeCard = ({
  fee,
  editing,
  feeInput,
  setFeeInput,
  saving,
  resetting,
  onEdit,
  onCancel,
  onSave,
  onReset,
  colors,
  isMobile,
}) => {
  const hasCustom = fee.is_custom;
  return (
    <Card colors={colors}>
      <div style={styles.cardHeader}>
        <div style={styles.cardTitleRow}>
          <Coins size={16} color={colors.btnBg} />
          <span style={styles.cardTitle(colors)}>Sub-agent registration fee</span>
          {hasCustom && (
            <span
              style={{
                ...styles.tonePill,
                background: colors.warningBg,
                color: colors.warning,
              }}
            >
              Custom
            </span>
          )}
          <span style={styles.chip(colors)}>
            {fee.sub_agent_count || 0} sub-agents
          </span>
        </div>

        {!editing ? (
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              onClick={onEdit}
              style={styles.ghostBtn(colors)}
            >
              <Edit2 size={14} /> Edit
            </button>
            {hasCustom && (
              <button
                type="button"
                onClick={onReset}
                disabled={resetting}
                style={styles.dangerGhostBtn(colors)}
              >
                {resetting ? (
                  <>
                    <RefreshCw
                      size={13}
                      style={{ animation: "spin 0.9s linear infinite" }}
                    />
                    Resetting…
                  </>
                ) : (
                  <>
                    <Trash2 size={14} /> Reset
                  </>
                )}
              </button>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              onClick={onCancel}
              style={styles.ghostBtn(colors)}
            >
              <X size={14} /> Cancel
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={saving}
              style={styles.primaryBtn(colors, saving)}
            >
              {saving ? (
                <>
                  <RefreshCw
                    size={13}
                    style={{ animation: "spin 0.9s linear infinite" }}
                  />
                  Saving…
                </>
              ) : (
                <>
                  <Save size={14} /> Save
                </>
              )}
            </button>
          </div>
        )}
      </div>

      <div style={styles.feeGrid}>
        <div style={styles.feeBlock}>
          <div style={styles.feeBlockLabel(colors)}>
            {hasCustom ? "Your fee" : "Base fee"}
          </div>
          {editing ? (
            <div style={styles.inputPrefixWrap}>
              <span style={styles.inputPrefix(colors)}>₵</span>
              <input
                type="number"
                value={feeInput}
                onChange={(e) => setFeeInput(e.target.value)}
                min={fee.base_fee}
                step="0.01"
                style={styles.inputWithPrefix(colors)}
                autoFocus
              />
            </div>
          ) : (
            <div
              style={{
                ...styles.feeValue,
                color: hasCustom ? colors.btnBg : colors.heading,
              }}
            >
              ₵{fee.current_fee || fee.base_fee || "0.00"}
            </div>
          )}
        </div>

        <div style={styles.feeBlock}>
          <div style={styles.feeBlockLabel(colors)}>Base fee</div>
          <div style={styles.feeValueMuted(colors)}>
            ₵{fee.base_fee || "0.00"}
          </div>
        </div>

        <div style={styles.feeBlock}>
          <div style={styles.feeBlockLabel(colors)}>Your profit</div>
          <div
            style={{
              ...styles.feeValue,
              color:
                fee.profit && parseFloat(fee.profit) > 0
                  ? colors.success
                  : colors.secondaryText,
            }}
          >
            {fee.profit && parseFloat(fee.profit) > 0
              ? `₵${fee.profit}`
              : "—"}
          </div>
        </div>
      </div>

      {fee.updated_at && !editing && (
        <div style={styles.feeFooter(colors)}>
          Last updated {formatDate(fee.updated_at)}
        </div>
      )}
    </Card>
  );
};

const PackageCard = ({
  pkg,
  colors,
  isMobile,
  expanded,
  onToggle,
  onEditCustomer,
  onEditSubAgent,
}) => {
  const meta = getNetworkMeta(pkg.network);
  const sourceMeta = PRICE_SOURCE_KEYS[pkg.priceSource] || PRICE_SOURCE_KEYS.base;
  const sourceTone = getToneColors(colors, sourceMeta.tone);

  const customerProfit =
    pkg.agentCustomerPrice != null
      ? pkg.agentCustomerPrice - pkg.basePriceAgent
      : null;
  const subProfit =
    pkg.agentSubBasePrice != null
      ? pkg.agentSubBasePrice - pkg.basePriceAgent
      : null;

  const customEntries = Object.entries(pkg.agentSubCustomPrices || {});
  const hasCustom = customEntries.length > 0;

  return (
    <div style={styles.pkgCard(colors)}>
      {/* Network strip */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 3,
          background: meta.dot,
        }}
      />

      {/* Header */}
      <div style={styles.pkgHeader}>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.4,
              textTransform: "uppercase",
              color: meta.dot,
              marginBottom: 4,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: meta.dot,
              }}
            />
            {meta.label}
          </div>
          <div style={styles.pkgSize(colors)}>{pkg.size}</div>
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <span
            style={{
              ...styles.tonePill,
              background: sourceTone.bg,
              color: sourceTone.fg,
            }}
          >
            <Info size={10} />
            {sourceMeta.label}
          </span>
          {pkg.salesCount > 0 && (
            <span
              style={{
                ...styles.tonePill,
                background: colors.hoverBg,
                color: colors.secondaryText,
              }}
            >
              <Zap size={10} />
              {pkg.salesCount}
            </span>
          )}
        </div>
      </div>

      {/* Base */}
      <div style={styles.priceRow(colors)}>
        <span style={styles.priceLabel(colors)}>Admin agent base</span>
        <span style={styles.priceValue(colors)}>
          ₵{pkg.basePriceAgent.toFixed(2)}
        </span>
      </div>

      {/* Two overlays */}
      <div style={styles.overlayGrid}>
        <PriceBlock
          label="Your customer price"
          value={pkg.agentCustomerPrice}
          base={pkg.basePriceAgent}
          profit={customerProfit}
          accentColor={colors.btnBg}
          colors={colors}
        />
        <PriceBlock
          label="Sub-agent base"
          value={pkg.agentSubBasePrice}
          base={pkg.basePriceAgent}
          profit={subProfit}
          accentColor={colors.linkColor}
          colors={colors}
        />
      </div>

      {/* Sub-agent customs */}
      {hasCustom && (
        <>
          <button
            type="button"
            onClick={onToggle}
            style={styles.expanderBtn(colors)}
          >
            <span>
              Sub-agent custom prices ({customEntries.length})
            </span>
            {expanded ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
          </button>
          {expanded && (
            <div style={styles.expanderBody(colors)}>
              {customEntries.map(([username, price]) => {
                const profit = price ? price - pkg.basePriceAgent : null;
                return (
                  <div key={username} style={styles.customRow(colors)}>
                    <span style={styles.customUser(colors)}>@{username}</span>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 12.5,
                          color: price ? colors.linkColor : colors.secondaryText,
                        }}
                      >
                        {price ? `₵${price.toFixed(2)}` : "Uses base"}
                      </span>
                      {profit != null && profit > 0 && (
                        <span
                          style={{
                            ...styles.tonePill,
                            background: colors.successBg,
                            color: colors.success,
                          }}
                        >
                          <BadgeDollarSign size={10} /> ₵{profit.toFixed(2)}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {/* Actions */}
      <div style={styles.pkgActions}>
        <button
          type="button"
          onClick={onEditCustomer}
          style={styles.ghostBtn(colors)}
        >
          <Edit2 size={13} /> {isMobile ? "Customer" : "Edit customer"}
        </button>
        <button
          type="button"
          onClick={onEditSubAgent}
          style={styles.ghostBtnAccent(colors)}
        >
          <Edit2 size={13} /> {isMobile ? "Sub-agent" : "Edit sub-agent"}
        </button>
      </div>
    </div>
  );
};

const PriceBlock = ({ label, value, base, profit, accentColor, colors }) => (
  <div style={styles.priceBlock(colors)}>
    <div style={styles.priceBlockLabel(colors)}>{label}</div>
    <div
      style={{
        fontSize: 15,
        fontWeight: 800,
        color: value ? accentColor : colors.secondaryText,
        letterSpacing: "-0.01em",
      }}
    >
      {value ? `₵${value.toFixed(2)}` : "Uses base"}
    </div>
    {value != null && (
      <span
        style={{
          ...styles.tonePill,
          background: profit > 0 ? colors.successBg : colors.errorBg,
          color: profit > 0 ? colors.success : colors.error,
          marginTop: 4,
        }}
      >
        <BadgeDollarSign size={10} />
        {profit > 0 ? `Profit ₵${profit.toFixed(2)}` : "No profit"}
      </span>
    )}
  </div>
);

const OrderStatusPill = ({ status, colors }) => {
  const map = {
    COMPLETED: { tone: "success", icon: CheckCircle },
    PENDING: { tone: "warning", icon: Clock },
    PROCESSING: { tone: "info", icon: RefreshCw },
    FAILED: { tone: "error", icon: AlertCircle },
  };
  const meta = map[status] || { tone: "muted", icon: AlertCircle };
  const t = getToneColors(colors, meta.tone);
  const Icon = meta.icon;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 11,
        fontWeight: 700,
        padding: "3px 8px",
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        textTransform: "capitalize",
      }}
    >
      <Icon size={10} />
      {status?.toLowerCase() || "n/a"}
    </span>
  );
};

const WeeklyChart = ({ data, activeTab, animating, colors, isMobile }) => {
  const series = {
    revenue: { data: data.revenue, color: colors.btnBg, label: "Revenue" },
    profit: { data: data.profit, color: colors.success, label: "Profit" },
    orders: { data: data.orders, color: colors.warning, label: "Orders" },
  }[activeTab];
  const max = Math.max(...series.data, 1);

  return (
    <div style={{ marginTop: 4 }}>
      <div style={styles.chartMeta(colors)}>
        <span>{series.label} per day</span>
        {data.summary && (
          <span>
            Total:{" "}
            <strong style={{ color: colors.heading }}>
              ₵{Number(data.summary.total_revenue || 0).toFixed(2)}
            </strong>
          </span>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          height: isMobile ? 130 : 170,
          gap: isMobile ? 4 : 8,
          marginTop: 10,
        }}
      >
        {series.data.map((value, i) => {
          const pct = max > 0 ? (value / max) * 100 : 0;
          const h = Math.max(pct, 2);
          return (
            <div
              key={i}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                height: "100%",
                justifyContent: "flex-end",
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: colors.secondaryText,
                  opacity: animating && value > 0 ? 1 : 0,
                  transition: "opacity 0.4s ease",
                }}
              >
                {value}
              </span>
              <div
                style={{
                  width: "100%",
                  maxWidth: 32,
                  height: `${animating ? h : 0}%`,
                  minHeight: animating ? 3 : 0,
                  background: `linear-gradient(180deg, ${series.color}, ${series.color}66)`,
                  borderRadius: "4px 4px 0 0",
                  transition:
                    "height 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)",
                }}
              />
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  color: colors.secondaryText,
                }}
              >
                {data.labels[i]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const PriceModal = ({
  pkg,
  type,
  priceInput,
  setPriceInput,
  submitting,
  onClose,
  onSave,
  colors,
  isMobile,
}) => {
  const isCustomer = type === "customer";
  const currentValue = isCustomer
    ? pkg.agentCustomerPrice
    : pkg.agentSubBasePrice;
  const currentProfit =
    currentValue != null ? currentValue - pkg.basePriceAgent : null;
  const newProfit = priceInput
    ? Number(priceInput) - pkg.basePriceAgent
    : 0;

  return (
    <div
      onClick={(e) => e.target === e.currentTarget && onClose()}
      style={styles.modalOverlay(colors)}
    >
      <div style={styles.modalCard(colors, isMobile)}>
        <div style={styles.modalHeader}>
          <div>
            <div style={styles.modalTitle(colors)}>
              {isCustomer ? "Edit customer price" : "Edit sub-agent base price"}
            </div>
            <div style={styles.modalSubtitle(colors)}>
              {pkg.network} · {pkg.size}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={styles.closeBtn(colors)}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>

        <div style={styles.modalBody}>
          <div style={styles.modalFacts(colors)}>
            <div style={styles.factRow}>
              <span style={styles.factLabel(colors)}>Admin agent base</span>
              <span style={styles.factValue(colors)}>
                ₵{pkg.basePriceAgent.toFixed(2)}
              </span>
            </div>
            <div style={styles.factRow}>
              <span style={styles.factLabel(colors)}>
                {isCustomer ? "Customer price" : "Sub-agent base"}
              </span>
              <span style={styles.factValue(colors)}>
                {currentValue != null ? `₵${currentValue.toFixed(2)}` : "Not set"}
              </span>
            </div>
            <div style={styles.factRow}>
              <span style={styles.factLabel(colors)}>Current profit</span>
              <span
                style={{
                  ...styles.factValue,
                  color:
                    currentProfit != null && currentProfit > 0
                      ? colors.success
                      : colors.secondaryText,
                }}
              >
                {currentProfit != null && currentProfit > 0
                  ? `₵${currentProfit.toFixed(2)}`
                  : "—"}
              </span>
            </div>
          </div>

          <label style={styles.modalLabel(colors)}>
            New {isCustomer ? "customer" : "sub-agent base"} price
          </label>
          <div style={styles.inputPrefixWrap}>
            <span style={styles.inputPrefix(colors)}>₵</span>
            <input
              type="number"
              value={priceInput}
              onChange={(e) => setPriceInput(e.target.value)}
              min={pkg.basePriceAgent}
              step="0.01"
              placeholder={`Min ₵${pkg.basePriceAgent.toFixed(2)}`}
              style={styles.inputWithPrefix(colors)}
              autoFocus
            />
          </div>
          <div style={styles.modalHint(colors)}>
            {newProfit > 0
              ? `New profit per sale: ₵${newProfit.toFixed(2)}`
              : "Set a price above the admin base to earn a profit"}
          </div>
        </div>

        <div style={styles.modalFooter}>
          <button
            type="button"
            onClick={onClose}
            style={styles.secondaryBtn(colors)}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={submitting}
            style={styles.primaryBtn(colors, submitting)}
          >
            {submitting ? (
              <>
                <RefreshCw
                  size={13}
                  style={{ animation: "spin 0.9s linear infinite" }}
                />
                Saving…
              </>
            ) : (
              <>
                <Save size={14} /> Save price
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   Styles
   ══════════════════════════════════════════════════════════ */

const styles = {
  pageWrap: {
    maxWidth: 1180,
    margin: "0 auto",
    padding: "20px 16px 60px",
  },
  loadingWrap: (c) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 400,
    gap: 14,
  }),
  spinner: (c) => ({
    width: 34,
    height: 34,
    border: `3px solid ${c.border}`,
    borderTopColor: c.btnBg,
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  }),

  header: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 14,
    marginBottom: 22,
  },
  h1: (c) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    margin: 0,
    fontSize: "clamp(20px, 3vw, 26px)",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    color: c.heading,
  }),
  subtitle: (c) => ({
    margin: "6px 0 0",
    fontSize: 13.5,
    color: c.secondaryText,
  }),

  card: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 16,
    padding: 20,
    marginBottom: 18,
  }),
  cardHeader: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 16,
  },
  cardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  cardTitle: (c) => ({
    fontSize: 15,
    fontWeight: 700,
    color: c.heading,
    letterSpacing: "-0.01em",
  }),
  cardSubtitle: (c) => ({
    fontSize: 12.5,
    color: c.secondaryText,
  }),

  statGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: 12,
    marginBottom: 18,
  },
  statCard: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 14,
    padding: 14,
    display: "flex",
    flexDirection: "column",
    gap: 6,
  }),
  statTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  statLabel: (c) => ({
    fontSize: 11.5,
    fontWeight: 600,
    color: c.secondaryText,
  }),
  statValue: (c) => ({
    fontSize: 20,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.02em",
  }),
  statChange: (c) => ({
    fontSize: 11,
    color: c.secondaryText,
  }),

  miniStatGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 10,
    marginBottom: 18,
  },
  miniStat: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 12,
    padding: "10px 12px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
  }),
  miniStatLabel: (c) => ({
    fontSize: 11,
    fontWeight: 600,
    color: c.secondaryText,
  }),
  miniStatValue: (c) => ({
    fontSize: 14.5,
    fontWeight: 700,
    color: c.heading,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),

  segmented: (c) => ({
    display: "inline-flex",
    border: `1px solid ${c.border}`,
    borderRadius: 9,
    overflow: "hidden",
    background: c.surfaceBg || c.raisedBg,
  }),
  segmentBtn: (c, active) => ({
    padding: "6px 12px",
    border: "none",
    background: active ? c.btnBg : "transparent",
    color: active ? c.btnText : c.secondaryText,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 700,
    textTransform: "capitalize",
    transition: "background 0.15s ease, color 0.15s ease",
  }),
  chartMeta: (c) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    fontSize: 12,
    color: c.secondaryText,
    flexWrap: "wrap",
  }),

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 500,
  },
  th: (c) => ({
    textAlign: "left",
    padding: "10px 12px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: c.secondaryText,
    borderBottom: `1px solid ${c.border}`,
  }),
  tr: (c) => ({
    borderBottom: `1px solid ${c.separator}`,
  }),
  td: (c) => ({
    padding: "12px",
    fontSize: 13,
    color: c.text,
    verticalAlign: "middle",
  }),
  mono: (c) => ({
    fontFamily: "ui-monospace, monospace",
    fontSize: 12,
    fontWeight: 600,
    color: c.heading,
  }),

  filtersRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 16,
    alignItems: "center",
  },
  searchWrap: {
    position: "relative",
    flex: "1 1 220px",
    minWidth: 0,
  },
  searchIcon: {
    position: "absolute",
    left: 12,
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  },
  searchInput: (c) => ({
    width: "100%",
    padding: "9px 34px 9px 36px",
    borderRadius: 10,
    border: `1px solid ${c.border}`,
    background: c.raisedBg,
    color: c.text,
    fontSize: 13,
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
  }),
  searchClear: {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
    display: "flex",
  },
  networkChips: {
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
  },
  networkChip: (c, active) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 12px",
    borderRadius: 999,
    border: `1px solid ${active ? c.btnBg : c.border}`,
    background: active ? c.btnBg : c.raisedBg,
    color: active ? c.btnText : c.text,
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s ease",
  }),

  pkgGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 12,
  },
  pkgCard: (c) => ({
    position: "relative",
    background: c.surfaceBg || c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 14,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    overflow: "hidden",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
  }),
  pkgHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 10,
    flexWrap: "wrap",
  },
  pkgSize: (c) => ({
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "-0.02em",
    color: c.heading,
  }),
  priceRow: (c) => ({
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    paddingBottom: 10,
    borderBottom: `1px solid ${c.separator || c.border}`,
  }),
  priceLabel: (c) => ({
    fontSize: 12,
    fontWeight: 600,
    color: c.secondaryText,
    textTransform: "uppercase",
    letterSpacing: 0.4,
  }),
  priceValue: (c) => ({
    fontSize: 15,
    fontWeight: 800,
    color: c.heading,
  }),

  overlayGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
  },
  priceBlock: (c) => ({
    padding: 10,
    borderRadius: 10,
    background: c.mainBg,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  }),
  priceBlockLabel: (c) => ({
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 0.3,
    textTransform: "uppercase",
    color: c.secondaryText,
  }),

  expanderBtn: (c) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    width: "100%",
    padding: "8px 0 0",
    borderTop: `1px solid ${c.separator || c.border}`,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
    color: c.secondaryText,
    textAlign: "left",
  }),
  expanderBody: (c) => ({
    background: c.mainBg,
    borderRadius: 10,
    padding: 10,
    display: "flex",
    flexDirection: "column",
    gap: 6,
  }),
  customRow: (c) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    paddingBottom: 6,
    borderBottom: `1px solid ${c.separator || c.border}`,
  }),
  customUser: (c) => ({
    fontSize: 12.5,
    color: c.text,
    fontWeight: 600,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),

  pkgActions: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 8,
    marginTop: "auto",
  },

  chip: (c) => ({
    padding: "3px 9px",
    borderRadius: 999,
    background: c.hoverBg,
    color: c.secondaryText,
    fontSize: 11,
    fontWeight: 700,
  }),
  tonePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "3px 9px",
    borderRadius: 999,
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 0.2,
    textTransform: "uppercase",
  },

  // Buttons
  ghostBtn: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 12px",
    borderRadius: 9,
    border: `1px solid ${c.border}`,
    background: "transparent",
    color: c.text,
    cursor: "pointer",
    fontSize: 12.5,
    fontWeight: 600,
    transition: "all 0.15s ease",
  }),
  ghostBtnAccent: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 12px",
    borderRadius: 9,
    border: `1px solid ${c.linkColor}`,
    background: "transparent",
    color: c.linkColor,
    cursor: "pointer",
    fontSize: 12.5,
    fontWeight: 600,
  }),
  dangerGhostBtn: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 12px",
    borderRadius: 9,
    border: `1px solid ${c.error}55`,
    background: "transparent",
    color: c.error,
    cursor: "pointer",
    fontSize: 12.5,
    fontWeight: 600,
  }),
  primaryBtn: (c, disabled) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 14px",
    borderRadius: 9,
    border: "none",
    background: disabled ? c.hoverBg : c.btnBg,
    color: disabled ? c.secondaryText : c.btnText,
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: 12.5,
    fontWeight: 700,
    transition: "background 0.15s ease",
  }),
  secondaryBtn: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "9px 16px",
    borderRadius: 9,
    border: `1px solid ${c.border}`,
    background: "transparent",
    color: c.text,
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
  }),
  linkBtn: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    background: "transparent",
    border: "none",
    color: c.btnBg,
    cursor: "pointer",
    fontSize: 12.5,
    fontWeight: 600,
  }),
  closeBtn: (c) => ({
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "none",
    background: c.hoverBg,
    color: c.text,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  }),

  // Fee card
  feeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: 14,
  },
  feeBlock: { minWidth: 0 },
  feeBlockLabel: (c) => ({
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: c.secondaryText,
    marginBottom: 4,
  }),
  feeValue: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "-0.02em",
  },
  feeValueMuted: (c) => ({
    fontSize: 20,
    fontWeight: 700,
    color: c.secondaryText,
  }),
  feeFooter: (c) => ({
    marginTop: 14,
    paddingTop: 10,
    borderTop: `1px solid ${c.separator || c.border}`,
    fontSize: 11.5,
    color: c.secondaryText,
  }),

  inputPrefixWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  inputPrefix: (c) => ({
    position: "absolute",
    left: 12,
    color: c.secondaryText,
    fontWeight: 700,
    fontSize: 14,
    pointerEvents: "none",
  }),
  inputWithPrefix: (c) => ({
    width: "100%",
    padding: "11px 12px 11px 30px",
    borderRadius: 10,
    border: `1.5px solid ${c.btnBg}`,
    background: c.raisedBg,
    color: c.text,
    fontSize: 15,
    fontWeight: 700,
    outline: "none",
    boxSizing: "border-box",
    transition: "box-shadow 0.15s ease",
  }),

  // Empty
  emptyState: (c) => ({
    padding: "40px 20px",
    textAlign: "center",
    color: c.secondaryText,
    border: `1px dashed ${c.border}`,
    borderRadius: 12,
    background: c.mainBg,
  }),

  // Modal
  modalOverlay: (c) => ({
    position: "fixed",
    inset: 0,
    background: c.scrim || "rgba(0,0,0,0.5)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 16,
    animation: "fadeIn 0.15s ease",
  }),
  modalCard: (c, isMobile) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 16,
    width: "100%",
    maxWidth: 440,
    padding: isMobile ? 20 : 24,
    boxShadow: `0 24px 64px ${c.shadowStrong || c.shadow}`,
    animation: "slideUp 0.2s ease",
    boxSizing: "border-box",
  }),
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
    marginBottom: 18,
  },
  modalTitle: (c) => ({
    fontSize: 16,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.01em",
  }),
  modalSubtitle: (c) => ({
    fontSize: 12.5,
    color: c.secondaryText,
    marginTop: 3,
  }),
  modalBody: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  modalFacts: (c) => ({
    background: c.mainBg,
    borderRadius: 12,
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }),
  factRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  factLabel: (c) => ({
    fontSize: 12,
    color: c.secondaryText,
    fontWeight: 600,
  }),
  factValue: (c) => ({
    fontSize: 13,
    fontWeight: 700,
    color: c.heading,
  }),
  modalLabel: (c) => ({
    fontSize: 12,
    fontWeight: 700,
    color: c.text,
    display: "block",
    marginBottom: 6,
  }),
  modalHint: (c) => ({
    fontSize: 11.5,
    color: c.secondaryText,
  }),
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 20,
  },
};